import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import SITE, { whatsappLink } from './siteConfig';

// Landing pública de talku.online (ruta "/"). No depende de sesión ni redirige.
// Estilos con prefijo "tl-" para no chocar con el resto de la app.
// Solo se anuncian funciones que existen en la plataforma. Los números dentro de las
// mini interfaces son ilustrativos (no son métricas reales ni afirmaciones comerciales).

const NAV = [
  { href: '#funciones', label: 'Funciones' },
  { href: '#ia', label: 'IA' },
  { href: '#dashboard', label: 'Dashboard' },
  { href: '#logistica', label: 'Logística' },
  { href: '#precios', label: 'Precios', pricing: true },
  { href: '#sectores', label: 'Para quién' },
  { href: '#faq', label: 'FAQ' },
];

// Red de integraciones: el catálogo de Configuración → Integraciones (Settings.js, INTEGRATIONS_DATA).
// Logos copiados de ahí. ring 0 = órbita interna (núcleo), ring 1 = órbita externa (herramientas).
const NET_CATS = ['Todas', 'Mensajería', 'E-commerce', 'Logística', 'IA', 'Automatización', 'Productividad'];

const NET_TOOLS = [
  { id: 'whatsapp', name: 'WhatsApp Business', cat: 'Mensajería', ring: 0,
    desc: 'Mensajes, plantillas y multimedia con la API oficial de Meta.',
    icon: <svg viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg> },
  { id: 'instagram', name: 'Instagram', cat: 'Mensajería', ring: 0,
    desc: 'Los mensajes directos de tus cuentas de Instagram, en tu bandeja.',
    icon: <svg viewBox="0 0 24 24" fill="none"><defs><linearGradient id="tl_ig" x1="1" y1="23" x2="23" y2="1" gradientUnits="userSpaceOnUse"><stop stopColor="#f9ce34" /><stop offset="0.3" stopColor="#ee2a7b" /><stop offset="1" stopColor="#6228d7" /></linearGradient></defs><rect x="1" y="1" width="22" height="22" rx="6" fill="url(#tl_ig)" /><circle cx="12" cy="12" r="4.5" stroke="#fff" strokeWidth="1.5" fill="none" /><circle cx="17.5" cy="6.5" r="1.2" fill="#fff" /></svg> },
  { id: 'messenger', name: 'Messenger', cat: 'Mensajería', ring: 0,
    desc: 'Las conversaciones de tus páginas de Facebook en el mismo lugar.',
    icon: <svg viewBox="0 0 24 24" fill="#0084FF"><path d="M12 0C5.37 0 0 4.97 0 11.11c0 3.5 1.74 6.62 4.47 8.66V24l4.09-2.24c1.09.3 2.24.46 3.44.46 6.63 0 12-4.97 12-11.11S18.63 0 12 0zm1.19 14.96l-3.06-3.26-5.97 3.26 6.57-6.98 3.13 3.26 5.9-3.26-6.57 6.98z" /></svg> },
  { id: 'shopify', name: 'Shopify', cat: 'E-commerce', ring: 0,
    desc: 'Pedidos, productos, clientes y fulfillment de tu tienda.',
    icon: <svg viewBox="0 0 109.5 124.5" fill="none"><path d="M95.6 28.2c-.1-.7-.7-1-1.1-1.1-.5 0-9.3-.7-9.3-.7s-7.4-7.2-8.1-7.9c-.7-.7-2.2-.5-2.8-.3 0 0-1.4.4-3.7 1.2-2.2-6.3-6-12.1-12.8-12.1h-.6C55.1 4.6 52.6 3 50.5 3c-15.8.2-23.4 19.7-25.7 29.7l-11 3.4c-3.4 1.1-3.5 1.2-4 4.4C9.5 42.7.5 111.5.5 111.5l75.6 13 32.6-8.1S95.7 28.9 95.6 28.2zM67.3 21.3l-5.7 1.8c0-3.3-.5-8-1.9-12 4.8 1 7.1 6.3 7.6 10.2zM55.6 24.3l-12.3 3.8c1.2-4.6 3.5-9.2 6.3-12.2 1-.1.2 2.5 3.6 4.3 1.7 1.7 2.5 4.1 2.4 4.1zM50.6 7.2c1.2 0 2.2.4 3 1.2C49.1 12.7 44 21 42.6 32l-9.8 3c2.7-9.2 8.3-27.8 17.8-27.8z" fill="#95BF47" /><path d="M94.5 27.1c-.5 0-9.3-.7-9.3-.7s-7.4-7.2-8.1-7.9c-.3-.3-.6-.4-1-.4l-4.5 92.4 32.6-8.1S95.7 28.9 95.6 28.2c-.1-.8-.6-1.1-1.1-1.1z" fill="#5E8E3E" /><path d="M57.4 43.5l-4.4 13.1s-3.8-2.1-8.5-2.1c-6.9 0-7.2 4.3-7.2 5.4 0 5.9 15.4 8.2 15.4 22.1 0 10.9-6.9 18-16.2 18-11.2 0-16.9-7-16.9-7l3-9.8s5.9 5.1 10.8 5.1c3.2 0 4.6-2.6 4.6-4.4 0-7.7-12.6-8.1-12.6-20.8 0-10.7 7.7-21 23.2-21 6 0 8.8 1.4 8.8 1.4z" fill="#fff" /></svg> },
  { id: 'nexus', name: 'Nexus', cat: 'Logística', ring: 0,
    desc: 'Plataforma de dropshipping y alianza oficial: guías, rastreo y novedades.',
    icon: <img src="/nexus-logo.png" alt="" /> },
  { id: 'openai', name: 'OpenAI', cat: 'IA', ring: 0,
    desc: 'Modelos de inteligencia artificial para tus agentes de atención y ventas.',
    icon: <svg viewBox="0 0 24 24" fill="#000"><path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" /></svg> },
  { id: 'n8n', name: 'n8n', cat: 'Automatización', ring: 1,
    desc: 'Automatiza flujos de pedidos y notificaciones.',
    icon: <svg viewBox="0 0 24 24" fill="#EA4B71"><path d="M21.4737 5.6842c-1.1772 0-2.1663.8051-2.4468 1.8947h-2.8955c-1.235 0-2.289.893-2.492 2.111l-.1038.623a1.263 1.263 0 0 1-1.246 1.0555H11.289c-.2805-1.0896-1.2696-1.8947-2.4468-1.8947s-2.1663.8051-2.4467 1.8947H4.973c-.2805-1.0896-1.2696-1.8947-2.4468-1.8947C1.1311 9.4737 0 10.6047 0 12s1.131 2.5263 2.5263 2.5263c1.1772 0 2.1663-.8051 2.4468-1.8947h1.4223c.2804 1.0896 1.2696 1.8947 2.4467 1.8947 1.1772 0 2.1663-.8051 2.4468-1.8947h1.0008a1.263 1.263 0 0 1 1.2459 1.0555l.1038.623c.203 1.218 1.257 2.111 2.492 2.111h.3692c.2804 1.0895 1.2696 1.8947 2.4468 1.8947 1.3952 0 2.5263-1.131 2.5263-2.5263s-1.131-2.5263-2.5263-2.5263c-1.1772 0-2.1664.805-2.4468 1.8947h-.3692a1.263 1.263 0 0 1-1.246-1.0555l-.1037-.623A2.52 2.52 0 0 0 13.9607 12a2.52 2.52 0 0 0 .821-1.4794l.1038-.623a1.263 1.263 0 0 1 1.2459-1.0555h2.8955c.2805 1.0896 1.2696 1.8947 2.4468 1.8947 1.3952 0 2.5263-1.131 2.5263-2.5263s-1.131-2.5263-2.5263-2.5263m0 1.2632a1.263 1.263 0 0 1 1.2631 1.2631 1.263 1.263 0 0 1-1.2631 1.2632 1.263 1.263 0 0 1-1.2632-1.2632 1.263 1.263 0 0 1 1.2632-1.2631M2.5263 10.7368A1.263 1.263 0 0 1 3.7895 12a1.263 1.263 0 0 1-1.2632 1.2632A1.263 1.263 0 0 1 1.2632 12a1.263 1.263 0 0 1 1.2631-1.2632m6.3158 0A1.263 1.263 0 0 1 10.1053 12a1.263 1.263 0 0 1-1.2632 1.2632A1.263 1.263 0 0 1 7.579 12a1.263 1.263 0 0 1 1.2632-1.2632m10.1053 3.7895a1.263 1.263 0 0 1 1.2631 1.2632 1.263 1.263 0 0 1-1.2631 1.2631 1.263 1.263 0 0 1-1.2632-1.2631 1.263 1.263 0 0 1 1.2632-1.2632" /></svg> },
  { id: 'zapier', name: 'Zapier', cat: 'Automatización', ring: 1,
    desc: 'Conecta Talku con miles de aplicaciones sin escribir código.',
    icon: <svg viewBox="0 0 24 24" fill="#FF4F00"><path d="M4.157 0A4.151 4.151 0 0 0 0 4.161v15.678A4.151 4.151 0 0 0 4.157 24h15.682A4.152 4.152 0 0 0 24 19.839V4.161A4.152 4.152 0 0 0 19.839 0H4.157Zm10.61 8.761h.03a.577.577 0 0 1 .23.038.585.585 0 0 1 .201.124.63.63 0 0 1 .162.431.612.612 0 0 1-.162.435.58.58 0 0 1-.201.128.58.58 0 0 1-.23.042.529.529 0 0 1-.235-.042.585.585 0 0 1-.332-.328.559.559 0 0 1-.038-.235.613.613 0 0 1 .17-.431.59.59 0 0 1 .405-.162Zm2.853 1.572c.03.004.061.004.095.004.325-.011.646.064.937.219.238.144.431.355.552.609.128.279.189.582.185.888v.193a2 2 0 0 1 0 .219h-2.498c.003.227.075.45.204.642a.78.78 0 0 0 .646.265.714.714 0 0 0 .484-.136.642.642 0 0 0 .23-.318l.915.257a1.398 1.398 0 0 1-.28.537c-.14.159-.321.284-.521.355a2.234 2.234 0 0 1-.836.136 1.923 1.923 0 0 1-1.001-.245 1.618 1.618 0 0 1-.665-.703 2.221 2.221 0 0 1-.227-1.036 1.95 1.95 0 0 1 .48-1.398 1.9 1.9 0 0 1 1.3-.488Zm-9.607.023c.162.004.325.026.48.079.207.065.4.174.563.314.26.302.393.692.366 1.088v2.276H8.53l-.109-.711h-.065c-.064.163-.155.31-.272.439a1.122 1.122 0 0 1-.374.264 1.023 1.023 0 0 1-.453.083 1.334 1.334 0 0 1-.866-.264.965.965 0 0 1-.329-.801.993.993 0 0 1 .076-.431 1.02 1.02 0 0 1 .242-.363 1.478 1.478 0 0 1 1.043-.303h.952v-.181a.696.696 0 0 0-.136-.454.553.553 0 0 0-.438-.154.695.695 0 0 0-.378.086.48.48 0 0 0-.193.254l-.99-.144a1.26 1.26 0 0 1 .257-.563c.14-.174.321-.302.533-.378.261-.091.54-.136.82-.129.053-.003.106-.007.163-.007Zm4.384.007c.174 0 .347.038.506.114.182.083.34.211.458.374.257.423.377.911.351 1.406a2.53 2.53 0 0 1-.355 1.448 1.148 1.148 0 0 1-1.009.517c-.204 0-.401-.045-.582-.136a1.052 1.052 0 0 1-.48-.457 1.298 1.298 0 0 1-.114-.234h-.045l.004 1.784h-1.059v-4.713h.904l.117.805h.057c.068-.208.177-.401.328-.56a1.129 1.129 0 0 1 .843-.344h.076v-.004Zm7.559.084h.903l.113.805h.053a1.37 1.37 0 0 1 .235-.484.813.813 0 0 1 .313-.242.82.82 0 0 1 .39-.076h.234v1.051h-.401a.662.662 0 0 0-.313.008.623.623 0 0 0-.272.155.663.663 0 0 0-.174.26.683.683 0 0 0-.027.314v1.875h-1.054v-3.666Zm-17.515.003h3.262v.896L3.73 13.104l.034.113h1.973l.042.9H2.4v-.9l1.931-1.754-.045-.117H2.441v-.896Zm11.815 0h1.055v3.659h-1.055V10.45Zm3.443.684.019.016a.69.69 0 0 0-.351.045.756.756 0 0 0-.287.204c-.11.155-.174.336-.189.522h1.545c-.034-.526-.257-.787-.74-.787h.003Zm-5.718.163c-.026 0-.057 0-.083.004a.78.78 0 0 0-.31.053.746.746 0 0 0-.257.189 1.016 1.016 0 0 0-.204.695v.064c-.015.257.057.507.204.711a.634.634 0 0 0 .253.196.638.638 0 0 0 .314.061.644.644 0 0 0 .578-.265c.14-.223.204-.48.189-.74a1.216 1.216 0 0 0-.181-.711.677.677 0 0 0-.503-.257Zm-4.509 1.266a.464.464 0 0 0-.268.102.373.373 0 0 0-.114.276c0 .053.008.106.027.155a.375.375 0 0 0 .087.132.576.576 0 0 0 .397.11v.004a.863.863 0 0 0 .563-.182.573.573 0 0 0 .211-.457v-.14h-.903Z" /></svg> },
  { id: 'zadarma', name: 'Zadarma', cat: 'Mensajería', ring: 1,
    desc: 'Llamadas VoIP entrantes y salientes integradas al CRM.',
    icon: <svg viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="6" fill="#2FC145" /><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.36 11.36 0 003.55.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.55 1 1 0 01-.25 1.02l-2.2 2.22z" fill="#fff" /></svg> },
  { id: 'sheets', name: 'Google Sheets', cat: 'Productividad', ring: 1,
    desc: 'Exporta pedidos, contactos y conversaciones a hojas de cálculo.',
    icon: <svg viewBox="0 0 24 24" fill="#34A853"><path d="M11.318 12.545H7.91v-1.909h3.41v1.91zM14.728 0v6h6l-6-6zm1.363 10.636h-3.41v1.91h3.41v-1.91zm0 3.273h-3.41v1.91h3.41v-1.91zM20.727 6.5v15.864c0 .904-.732 1.636-1.636 1.636H4.909a1.636 1.636 0 0 1-1.636-1.636V1.636C3.273.732 4.005 0 4.909 0h9.318v6.5h6.5zm-3.273 2.773H6.545v7.909h10.91v-7.91zm-6.136 4.636H7.91v1.91h3.41v-1.91z" /></svg> },
  { id: 'mailchimp', name: 'Mailchimp', cat: 'Automatización', ring: 1,
    desc: 'Audiencias sincronizadas con tus contactos para campañas de email.',
    icon: <svg viewBox="0 0 24 24"><rect width="24" height="24" rx="6" fill="#FFE01B" /><path transform="translate(4 4) scale(.6667)" fill="#000" d="M11.267 0C6.791-.015-1.82 10.246 1.397 12.964l.79.669a3.88 3.88 0 0 0-.22 1.792c.084.84.518 1.644 1.22 2.266.666.59 1.542.964 2.392.964 1.406 3.24 4.62 5.228 8.386 5.34 4.04.12 7.433-1.776 8.854-5.182.093-.24.488-1.316.488-2.267 0-.956-.54-1.352-.885-1.352-.01-.037-.078-.286-.172-.586-.093-.3-.19-.51-.19-.51.375-.563.382-1.065.332-1.35-.053-.353-.2-.653-.496-.964-.296-.311-.902-.63-1.753-.868l-.446-.124c-.002-.019-.024-1.053-.043-1.497-.014-.32-.042-.822-.197-1.315-.186-.668-.508-1.253-.911-1.627 1.112-1.152 1.806-2.422 1.804-3.511-.003-2.095-2.576-2.729-5.746-1.416l-.672.285A678.22 678.22 0 0 0 12.7.504C12.304.159 11.817.002 11.267 0zm.073.873c.166 0 .322.019.465.058.297.084 1.28 1.224 1.28 1.224s-1.826 1.013-3.52 2.426c-2.28 1.757-4.005 4.311-5.037 7.082-.811.158-1.526.618-1.963 1.253-.261-.218-.748-.64-.834-.804-.698-1.326.761-3.902 1.781-5.357C5.834 3.44 9.37.867 11.34.873zm3.286 3.273c.04-.002.06.05.028.074-.143.11-.299.26-.413.414a.04.04 0 0 0 .031.064c.659.004 1.587.235 2.192.574.041.023.012.103-.034.092-.915-.21-2.414-.369-3.97.01-1.39.34-2.45.863-3.224 1.426-.04.028-.086-.023-.055-.06.896-1.035 1.999-1.935 2.987-2.44.034-.018.07.019.052.052-.079.143-.23.447-.278.678-.007.035.032.063.062.042.615-.42 1.684-.868 2.622-.926zm3.023 3.205l.056.001a.896.896 0 0 1 .456.146c.534.355.61 1.216.638 1.845.015.36.059 1.229.074 1.478.034.571.184.651.487.751.17.057.33.098.563.164.706.198 1.125.4 1.39.658.157.162.23.333.253.497.083.608-.472 1.36-1.942 2.041-1.607.746-3.557.935-4.904.785l-.471-.053c-1.078-.145-1.693 1.247-1.046 2.201.417.615 1.552 1.015 2.688 1.015 2.604 0 4.605-1.111 5.35-2.072a.987.987 0 0 0 .06-.085c.036-.055.006-.085-.04-.054-.608.416-3.31 2.069-6.2 1.571 0 0-.351-.057-.672-.182-.255-.1-.788-.344-.853-.891 2.333.72 3.801.039 3.801.039a.072.072 0 0 0 .042-.072.067.067 0 0 0-.074-.06s-1.911.283-3.718-.378c.197-.64.72-.408 1.51-.345a11.045 11.045 0 0 0 3.647-.394c.818-.234 1.892-.697 2.727-1.356.281.618.38 1.299.38 1.299s.219-.04.4.073c.173.106.299.326.213.895-.176 1.063-.628 1.926-1.387 2.72a5.714 5.714 0 0 1-1.666 1.244c-.34.18-.704.334-1.087.46-2.863.935-5.794-.093-6.739-2.3a3.545 3.545 0 0 1-.189-.522c-.403-1.455-.06-3.2 1.008-4.299.065-.07.132-.153.132-.256 0-.087-.055-.179-.102-.243-.374-.543-1.669-1.466-1.409-3.254.187-1.284 1.31-2.189 2.357-2.135.089.004.177.01.266.015.453.027.85.085 1.223.1.625.028 1.187-.063 1.853-.618.225-.187.405-.35.71-.401.028-.005.092-.028.215-.028zm.022 2.18a.42.42 0 0 0-.06.005c-.335.054-.347.468-.228 1.04.068.32.187.595.32.765.175-.02.343-.022.498 0 .089-.205.104-.557.024-.942-.112-.535-.261-.872-.554-.868zm-3.66 1.546a1.724 1.724 0 0 0-1.016.326c-.16.117-.311.28-.29.378.008.032.031.056.088.063.131.015.592-.217 1.122-.25.374-.023.684.094.923.2.239.104.386.173.443.113.037-.038.026-.11-.031-.204-.118-.192-.36-.387-.618-.497a1.601 1.601 0 0 0-.621-.129zm4.082.81c-.171-.003-.313.186-.317.42-.004.236.131.43.303.432.172.003.314-.185.318-.42.004-.236-.132-.429-.304-.432zm-3.58.172c-.05 0-.102.002-.155.008-.311.05-.483.152-.593.247-.094.082-.152.173-.152.237a.075.075 0 0 0 .075.076c.07 0 .228-.063.228-.063a1.98 1.98 0 0 1 1.001-.104c.157.018.23.027.265-.026.01-.016.022-.049-.01-.1-.063-.103-.311-.269-.66-.275zm2.26.4c-.127 0-.235.051-.283.148-.075.154.035.363.246.466.21.104.443.063.52-.09.075-.155-.035-.364-.246-.467a.542.542 0 0 0-.237-.058zm-11.635.024c.048 0 .098 0 .149.003.73.04 1.806.6 2.052 2.19.217 1.41-.128 2.843-1.449 3.069-.123.02-.248.029-.374.026-1.22-.033-2.539-1.132-2.67-2.435-.145-1.44.591-2.548 1.894-2.811.117-.024.252-.04.398-.042zm-.07.927a1.144 1.144 0 0 0-.847.364c-.38.418-.439.988-.366 1.19.027.073.07.094.1.098.064.008.16-.039.22-.2a1.2 1.2 0 0 0 .017-.052 1.58 1.58 0 0 1 .157-.37.689.689 0 0 1 .955-.199c.266.174.369.5.255.81-.058.161-.154.469-.133.721.043.511.357.717.64.738.274.01.466-.143.515-.256.029-.067.005-.107-.011-.125-.043-.053-.113-.037-.18-.021a.638.638 0 0 1-.16.022.347.347 0 0 1-.294-.148c-.078-.12-.073-.3.013-.504.011-.028.025-.058.04-.092.138-.308.368-.825.11-1.317-.195-.37-.513-.602-.894-.65a1.135 1.135 0 0 0-.138-.01z" /></svg> },
  { id: 'slack', name: 'Slack', cat: 'Productividad', ring: 1,
    desc: 'Alertas de pedidos y conversaciones directamente en tus canales.',
    icon: <svg viewBox="0 0 24 24" fill="#4A154B"><path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" /></svg> },
  { id: 'analytics', name: 'Google Analytics', cat: 'Productividad', ring: 1,
    desc: 'Conversiones de tu embudo de ventas conectadas con el CRM.',
    icon: <svg viewBox="0 0 24 24" fill="#E37400"><path d="M22.84 2.9982v17.9987c.0086 1.6473-1.3197 2.9897-2.967 2.9984a2.9808 2.9808 0 01-.3677-.0208c-1.528-.226-2.6477-1.5558-2.6105-3.1V3.1204c-.0369-1.5458 1.0856-2.8762 2.6157-3.1 1.6361-.1915 3.1178.9796 3.3093 2.6158.014.1201.0208.241.0202.3619zM4.1326 18.0548c-1.6417 0-2.9726 1.331-2.9726 2.9726C1.16 22.6691 2.4909 24 4.1326 24s2.9726-1.3309 2.9726-2.9726-1.331-2.9726-2.9726-2.9726zm7.8728-9.0098c-.0171 0-.0342 0-.0513.0003-1.6495.0904-2.9293 1.474-2.891 3.1256v7.9846c0 2.167.9535 3.4825 2.3505 3.763 1.6118.3266 3.1832-.7152 3.5098-2.327.04-.1974.06-.3983.0593-.5998v-8.9585c.003-1.6474-1.33-2.9852-2.9773-2.9882z" /></svg> },
  { id: 'webhook', name: 'Webhooks', cat: 'Automatización', ring: 1,
    desc: 'Envía los eventos de Talku a cualquier sistema externo.',
    icon: <svg viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="6" fill="#6b7280" /><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" /><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" /></svg> },
];

const HERO_WORDS = [
  { t: 'Vende' }, { t: 'por' }, { t: 'chat,' },
  { t: 'del', em: true }, { t: 'mensaje', em: true },
  { t: 'a' }, { t: 'la' }, { t: 'entrega' },
];

const CHAT = [
  { who: 'in', text: 'Hola, ¿tienen las zapatillas en talla 38?' },
  { who: 'out', text: '¡Hola! Sí 👟 Tenemos talla 38 en negro y en blanco. ¿Cuál te gusta más?' },
  { who: 'in', text: 'Las negras. ¿Puedo pagar contra entrega?' },
  { who: 'out', text: '¡Claro! Ya confirmé tu pedido y te aviso apenas tenga tu guía 📦' },
];

const AI_POINTS = [
  'Responde, recomienda productos, cotiza el envío y toma el pedido 24/7',
  'Aprende de tu base de conocimiento y tu catálogo',
  'Varios agentes configurables, con pruebas antes de activarlos',
  'Flujos automáticos en un constructor visual, o generados por la IA',
  'Respuestas automáticas a comentarios en Instagram y Facebook',
  'Video IA: videos para anuncios a partir de un texto o una imagen',
];

const DASHBOARD_POINTS = [
  'Ventas y pedidos del día, la semana o el rango que elijas',
  'Gráficas de tendencia para comparar periodos',
  'Productos más vendidos, con la imagen de cada uno',
  'Pedidos por estado: por confirmar, por pagar, listos para guía, en camino',
  'Actualización en vivo, sin recargar la página',
];

// "Para tu equipo": ecosistema comercial (referencia: arborainbox.com, sección #modulos).
// Las tarjetas replican el diseño real de Dashboard.js, Conversations.js y Orders.js con datos de prueba.
const TEAM_PILLARS = [
  { title: 'Dashboard en tiempo real', text: 'Ventas, pedidos y conversaciones activas del día, con la evolución y el pipeline de pedidos.' },
  { title: 'Conversaciones unificadas', text: 'WhatsApp, Instagram y Messenger en una bandeja, con asignación por asesor, etiquetas y respuestas rápidas.' },
  { title: 'Pedidos bajo control', text: 'Cada pedido con su estado, de "Sin confirmar" a "Entregado", con su pago, su guía y sus novedades.' },
  { title: 'Tu equipo sincronizado', text: 'Roles, canales por asesor y avisos de mensajes nuevos al instante.' },
];

// Logística = alianza oficial Talku × Nexus. Datos de Nexus tomados de su propio sitio (nexusdrops.online).
const NEXUS_URL = 'https://nexusdrops.online';
const NEXUS_FACTS = [
  'Miles de productos listos para vender, sin inventario',
  'Liquidación diaria de tus ganancias',
  'Devoluciones a $0',
  'Contra entrega sin saldo precargado',
  'Envíos con Coordinadora, Interrapidísimo, Servientrega, Envía y TCC',
];
const TALKU_FOR_NEXUS = [
  'Tus pedidos de Shopify vinculados con Nexus',
  'Cotización del envío por ciudad desde el chat',
  'Guía y rótulo en un clic',
  'Aviso automático a tu bodega por WhatsApp',
  'Rastreo y novedades, con avisos a tu cliente',
];

const SECURITY_POINTS = [
  { icon: 'users', title: 'Roles y permisos', text: 'Dueño, administrador y asesor: cada quien ve lo que le corresponde.' },
  { icon: 'shield', title: 'API oficial de Meta', text: 'Sin códigos QR ni riesgo de bloqueo por apps no autorizadas.' },
  { icon: 'lock', title: 'Datos aislados', text: 'La información de cada empresa está separada de las demás.' },
  { icon: 'database', title: 'Copias diarias', text: 'Tu información se respalda todos los días de forma automática.' },
];

const STEPS = [
  { n: '01', title: 'Conecta tus canales', text: 'Vincula WhatsApp, Instagram, Messenger y tu tienda.' },
  { n: '02', title: 'Configura tu agente', text: 'Carga tus productos, precios y reglas de envío.' },
  { n: '03', title: 'Vende y despacha', text: 'Tu equipo y la IA atienden, confirman y envían cada pedido.' },
];

// Talku no tiene agenda de citas: el sector salud se enfoca en consultas, no en agendar.
const SECTORS = [
  { icon: 'bag', kicker: 'Retail y e-commerce', title: 'Tiendas de ropa, calzado y comercio online',
    text: 'Varios asesores y la IA atendiendo WhatsApp e Instagram a la vez, con pedidos contra entrega, guías y rastreo en el mismo lugar.',
    tags: ['Pedidos por WhatsApp', 'Contra entrega', 'Varios asesores'] },
  { icon: 'pulse', kicker: 'Servicios', title: 'Salud, estética, odontología y consultorías',
    text: 'Responde al instante las consultas de pacientes y clientes, con la IA atendiendo preguntas frecuentes 24/7 y cada conversación asignada a la persona correcta.',
    tags: ['Consultas 24/7', 'Respuestas rápidas', 'Asignación por asesor'] },
  { icon: 'box', kicker: 'Distribución y mayoristas', title: 'Ferreterías, alimentos, autopartes y mayoristas',
    text: 'Envía catálogos y listas de precios en segundos, organiza cada cliente con etiquetas y consulta el historial de pedidos de cada uno.',
    tags: ['Catálogos y precios', 'Clientes recurrentes', 'Historial de pedidos'] },
];

const FAQS = [
  { q: '¿Talku usa la API oficial de WhatsApp?', a: 'Sí. Talku se conecta con la API oficial de WhatsApp Business de Meta. No usa conexión por código QR, así que tu número no corre el riesgo de bloqueo que tienen las aplicaciones no autorizadas.' },
  { q: '¿Puedo tener varios asesores?', a: 'Sí. Puedes invitar a tu equipo con roles de administrador o asesor, asignar conversaciones a cada persona y definir qué canales atiende cada una.' },
  { q: '¿La IA responde sola o puedo intervenir?', a: 'La IA puede atender 24/7, y en cualquier conversación puedes pausarla con un clic para responder tú mismo. Cuando quieras, la vuelves a activar.' },
  { q: '¿Con qué transportadoras funciona?', a: 'A través de Nexus, nuestra alianza oficial de dropshipping, con Coordinadora, Interrapidísimo, Servientrega, Envía y TCC. Puedes cotizar por ciudad, generar la guía, descargar el rótulo y rastrear cada envío.' },
  { q: '¿Se integra con Shopify?', a: 'Sí. Los pedidos de tu tienda Shopify llegan a Talku, donde puedes confirmarlos, gestionar el pago y despacharlos.' },
  { q: '¿Qué medios de pago maneja?', a: 'Pedidos contra entrega y pagos con ADDI, Sistecrédito, Wompi, MercadoPago y Openpay. Talku sigue el estado de cada pago y ayuda a recuperar los que fallan.' },
  { q: '¿Mis datos están seguros?', a: 'La información de cada empresa está aislada, el acceso se controla por roles y se hacen copias de seguridad diarias. Consulta nuestra Política de Privacidad para más detalle.' },
  { q: '¿Cómo empiezo?', a: 'Crea tu cuenta o escríbenos, y te acompañamos a conectar tus canales y configurar tu agente.' },
];

const LEGAL_LINKS = [
  { href: '/terminos', label: 'Términos y Condiciones' },
  { href: '/privacidad', label: 'Política de Privacidad' },
  { href: '/tratamiento-datos', label: 'Tratamiento de Datos' },
  { href: '/cookies', label: 'Política de Cookies' },
  { href: '/eliminacion-datos', label: 'Eliminación de datos' },
];

const CARRIERS = [
  { src: '/coordinadora-logo.webp', alt: 'Coordinadora' },
  { src: '/interrapidisimo-logo.jpg', alt: 'Interrapidísimo' },
  { src: '/servientrega-logo.jpg', alt: 'Servientrega' },
  { src: '/envia-logo.jpg', alt: 'Envía' },
  { src: '/tcc-logo.jpg', alt: 'TCC' },
];

// Parámetros del vidrio líquido: "borde de refracción (px), intensidad (px), desenfoque (px)".
const GLASS_BAR = '20,56,6';
const GLASS_BTN = '14,38,2';
const GLASS_CARD = '16,44,3';

const reducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// ── Vidrio líquido real (Chromium) ───────────────────────────────
// Genera por elemento un mapa de desplazamiento con la forma exacta (rectángulo redondeado)
// y lo aplica como backdrop-filter SVG: el fondo se refracta en los bordes como una lente.
// Safari/Firefox no soportan filtros SVG en backdrop-filter: ahí queda el vidrio esmerilado del CSS.
const SVG_NS = 'http://www.w3.org/2000/svg';

function buildDisplacementMap(w, h, radius, edge) {
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  const img = ctx.createImageData(w, h);
  const d = img.data;
  const hw = w / 2;
  const hh = h / 2;
  const r = Math.min(radius, hw, hh);
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const px = x + 0.5 - hw;
      const py = y + 0.5 - hh;
      const ax = Math.abs(px);
      const ay = Math.abs(py);
      const qx = ax - (hw - r);
      const qy = ay - (hh - r);
      let dist; let nx; let ny;
      if (qx > 0 && qy > 0) {
        const len = Math.hypot(qx, qy) || 1;
        dist = r - len; nx = qx / len; ny = qy / len;
      } else if (qx > qy) {
        dist = hw - ax; nx = 1; ny = 0;
      } else {
        dist = hh - ay; nx = 0; ny = 1;
      }
      nx *= px < 0 ? -1 : 1;
      ny *= py < 0 ? -1 : 1;
      let m = 0;
      if (dist < edge) {
        const t = 1 - Math.max(dist, 0) / edge;
        m = t * t;
      }
      const i = (y * w + x) * 4;
      d[i] = 128 - nx * m * 127;
      d[i + 1] = 128 - ny * m * 127;
      d[i + 2] = 128;
      d[i + 3] = 255;
    }
  }
  ctx.putImageData(img, 0, 0);
  return canvas.toDataURL();
}

function useLiquidGlass(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    const chromium = typeof navigator !== 'undefined' && !!navigator.userAgentData;
    const cssApi = window.CSS;
    if (!root || !chromium || !cssApi || typeof cssApi.supports !== 'function' || !cssApi.supports('backdrop-filter', 'blur(1px)')) return undefined;

    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.position = 'absolute';
    const defs = document.createElementNS(SVG_NS, 'defs');
    svg.appendChild(defs);
    document.body.appendChild(svg);

    const state = new Map();
    let seq = 0;

    // Efecto decorativo: si algo falla, se desactiva en ese elemento y la página sigue normal.
    const apply = (el) => {
      try {
        applyLiquid(el);
      } catch (err) {
        el.style.backdropFilter = '';
        el.classList.remove('tl-refracting');
      }
    };

    const applyLiquid = (el) => {
      const w = Math.round(el.offsetWidth);
      const h = Math.round(el.offsetHeight);
      if (!w || !h) return;
      let s = state.get(el);
      if (!s) { s = { id: `tl-lg-${++seq}` }; state.set(el, s); }
      if (s.w === w && s.h === h) return;
      s.w = w; s.h = h;
      const [edge, scale, blur] = (el.dataset.liquid || GLASS_BTN).split(',').map(Number);
      const radius = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
      const map = buildDisplacementMap(w, h, radius, Math.min(edge, w / 2, h / 2));
      if (!s.filter) {
        const f = document.createElementNS(SVG_NS, 'filter');
        f.setAttribute('id', s.id);
        f.setAttribute('filterUnits', 'userSpaceOnUse');
        f.setAttribute('primitiveUnits', 'userSpaceOnUse');
        f.setAttribute('color-interpolation-filters', 'sRGB');
        f.setAttribute('x', '0');
        f.setAttribute('y', '0');
        const fi = document.createElementNS(SVG_NS, 'feImage');
        fi.setAttribute('x', '0');
        fi.setAttribute('y', '0');
        fi.setAttribute('preserveAspectRatio', 'none');
        fi.setAttribute('result', 'map');
        const fd = document.createElementNS(SVG_NS, 'feDisplacementMap');
        fd.setAttribute('in', 'SourceGraphic');
        fd.setAttribute('in2', 'map');
        fd.setAttribute('xChannelSelector', 'R');
        fd.setAttribute('yChannelSelector', 'G');
        f.appendChild(fi);
        f.appendChild(fd);
        defs.appendChild(f);
        s.filter = f; s.image = fi; s.disp = fd;
      }
      s.filter.setAttribute('width', String(w));
      s.filter.setAttribute('height', String(h));
      s.image.setAttribute('width', String(w));
      s.image.setAttribute('height', String(h));
      s.image.setAttribute('href', map);
      s.disp.setAttribute('scale', String(scale));
      el.style.backdropFilter = `url(#${s.id}) blur(${blur}px) saturate(1.8)`;
      el.classList.add('tl-refracting');
    };

    // Durante transiciones de tamaño (ej. el header al encogerse) el mapa se recalcula solo al final.
    const timers = new Map();
    const ro = new ResizeObserver(entries => entries.forEach(e => {
      clearTimeout(timers.get(e.target));
      timers.set(e.target, setTimeout(() => apply(e.target), 140));
    }));
    const scan = () => {
      state.forEach((s, el) => {
        if (!el.isConnected) { ro.unobserve(el); if (s.filter) s.filter.remove(); state.delete(el); }
      });
      root.querySelectorAll('[data-liquid]').forEach(el => {
        if (!state.has(el)) { ro.observe(el); apply(el); }
      });
    };
    try { scan(); } catch (err) { /* sin vidrio líquido: queda el esmerilado del CSS */ }
    const mo = new MutationObserver(() => { try { scan(); } catch (err) { /* idem */ } });
    mo.observe(root, { childList: true, subtree: true });

    return () => {
      timers.forEach(t => clearTimeout(t));
      ro.disconnect();
      mo.disconnect();
      svg.remove();
      state.forEach((_, el) => { el.style.backdropFilter = ''; el.classList.remove('tl-refracting'); });
    };
  }, [rootRef]);
}

// ── Iconos de línea ──────────────────────────────────────────────
const ICONS = {
  users: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>,
  tag: <><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><circle cx="7" cy="7" r="1.5" /></>,
  hand: <><path d="M18 11V6a2 2 0 0 0-4 0v5M14 10V4a2 2 0 0 0-4 0v6M10 10.5V6a2 2 0 0 0-4 0v8" /><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15" /></>,
  zap: <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />,
  badge: <><path d="M12 2l2.4 2.2 3.2-.4.9 3.1 2.9 1.5-1.2 3 1.2 3-2.9 1.5-.9 3.1-3.2-.4L12 22l-2.4-2.2-3.2.4-.9-3.1-2.9-1.5 1.2-3-1.2-3 2.9-1.5.9-3.1 3.2.4z" /><path d="m9 12 2 2 4-4" /></>,
  bell: <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></>,
  book: <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35" /></>,
  shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></>,
  lock: <><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>,
  database: <><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" /><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" /></>,
  check: <path d="M20 6 9 17l-5-5" />,
  arrow: <><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></>,
  bag: <><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" /></>,
  pulse: <><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" /><path d="M3.5 12h4l1.5-3 3 6 1.5-3h4" /></>,
  box: <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><path d="M3.27 6.96 12 12.01l8.73-5.05" /><path d="M12 22.08V12" /></>,
  star: <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />,
  external: <><path d="M15 3h6v6" /><path d="M10 14 21 3" /><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /></>,
  truck: <><path d="M1 3h15v13H1z" /><path d="M16 8h4l3 3v5h-7z" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" /></>,
};

function Icon({ name, size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {ICONS[name]}
    </svg>
  );
}

// ── Piezas animadas ──────────────────────────────────────────────
function CountUp({ to, prefix = '', duration = 1600 }) {
  const ref = useRef(null);
  const [value, setValue] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (reducedMotion() || !('IntersectionObserver' in window)) { setValue(to); return undefined; }
    let raf = 0;
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const tick = (now) => {
        const k = Math.min(1, (now - t0) / duration);
        setValue(Math.round(to * (1 - Math.pow(1 - k, 3))));
        if (k < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    io.observe(el);
    return () => { io.disconnect(); cancelAnimationFrame(raf); };
  }, [to, duration]);
  return <span ref={ref} className="tl-num">{prefix}{value.toLocaleString('es-CO')}</span>;
}

function AreaChart({ points, height = 110, id }) {
  const w = 300;
  const step = w / (points.length - 1);
  const xy = points.map((p, i) => [i * step, height - (p / 100) * height]);
  const line = xy.map(([x, y], i) => {
    if (i === 0) return `M${x},${y}`;
    const [px, py] = xy[i - 1];
    const cx = (px + x) / 2;
    return `C${cx},${py} ${cx},${y} ${x},${y}`;
  }).join(' ');
  const area = `${line} L${w},${height} L0,${height} Z`;
  const [lx, ly] = xy[xy.length - 1];
  return (
    <svg viewBox={`0 0 ${w} ${height}`} preserveAspectRatio="none" className="tl-chart" aria-hidden="true">
      <defs>
        <linearGradient id={`g-${id}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#a3e31c" stopOpacity=".5" />
          <stop offset="100%" stopColor="#a3e31c" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#g-${id})`} />
      <path d={line} fill="none" stroke="#65a30d" strokeWidth="2.5" vectorEffect="non-scaling-stroke" />
      <circle cx={lx} cy={ly} r="4" className="tl-chart-dot" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}

function useChatSequence() {
  const [s, setS] = useState(() => (reducedMotion()
    ? { n: CHAT.length, typing: null, f: 3, out: false }
    : { n: 0, typing: null, f: 0, out: false }));
  useEffect(() => {
    if (reducedMotion()) return undefined;
    let alive = true;
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    (async () => {
      await sleep(1100);
      while (alive) {
        for (let i = 0; i < CHAT.length; i++) {
          if (!alive) return;
          setS(p => ({ ...p, typing: CHAT[i].who }));
          await sleep(CHAT[i].who === 'out' ? 1500 : 1000);
          if (!alive) return;
          setS(p => ({ ...p, typing: null, n: i + 1 }));
          await sleep(850);
        }
        for (let f = 1; f <= 3; f++) {
          if (!alive) return;
          setS(p => ({ ...p, f }));
          await sleep(950);
        }
        await sleep(3400);
        if (!alive) return;
        setS(p => ({ ...p, out: true }));
        await sleep(650);
        if (!alive) return;
        setS({ n: 0, typing: null, f: 0, out: false });
        await sleep(600);
      }
    })();
    return () => { alive = false; };
  }, []);
  return s;
}

function HeroStage() {
  const { n, typing, f, out } = useChatSequence();
  const stageRef = useRef(null);
  const onMove = (e) => {
    const el = stageRef.current;
    if (!el || e.pointerType !== 'mouse') return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--px', (((e.clientX - r.left) / r.width) - 0.5).toFixed(3));
    el.style.setProperty('--py', (((e.clientY - r.top) / r.height) - 0.5).toFixed(3));
  };
  const onLeave = () => {
    const el = stageRef.current;
    if (!el) return;
    el.style.setProperty('--px', '0');
    el.style.setProperty('--py', '0');
  };
  const floats = [
    { cls: 'tl-f1', icon: 'check', title: 'Pedido confirmado', sub: 'Contra entrega' },
    { cls: 'tl-f2', icon: 'truck', title: 'Guía generada', sub: 'Coordinadora' },
    { cls: 'tl-f3', icon: 'bell', title: 'Bodega notificada', sub: 'Por WhatsApp' },
  ];
  return (
    <div className="tl-stage" ref={stageRef} onPointerMove={onMove} onPointerLeave={onLeave} aria-hidden="true">
      <span className="tl-stage-glow" />
      <div className="tl-phone">
        <div className="tl-screen">
          <div className="tl-screen-head">
            <div className="tl-avatar"><img src="/talku-symbol.png" alt="" /></div>
            <div><b>Talku IA</b><span>{typing === 'out' ? 'escribiendo…' : 'en línea'}</span></div>
          </div>
          <div className={`tl-chat${out ? ' tl-chat-out' : ''}`}>
            {CHAT.slice(0, n).map((m, i) => (
              <div key={i} className={`tl-msg tl-msg-${m.who}`}>{m.text}</div>
            ))}
            {typing && (
              <div className={`tl-msg tl-msg-${typing} tl-typing`}><i /><i /><i /></div>
            )}
          </div>
        </div>
      </div>
      {floats.map((fl, i) => (
        <div key={fl.cls} className={`tl-float ${fl.cls}${f > i ? ' tl-show' : ''}`}>
          <div className="tl-float-in tl-glass" data-liquid={GLASS_CARD}>
            <span className="tl-float-ico"><Icon name={fl.icon} size={16} /></span>
            <div><b>{fl.title}</b><span>{fl.sub}</span></div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── Red interactiva de integraciones ─────────────────────────────
// Dos órbitas elípticas alrededor de Talku. Las posiciones se calculan en un bucle rAF
// y se escriben directo en el DOM (sin re-render). Al pasar el mouse la órbita frena.
function IntegrationNetwork() {
  const boxRef = useRef(null);
  const svgRef = useRef(null);
  const nodes = useRef({});
  const links = useRef({});
  const pulses = useRef({});
  const pointer = useRef({ x: 0, y: 0 });
  const hoverRef = useRef(null);
  const [hover, setHover] = useState(null);
  const [tip, setTip] = useState({ below: false, align: 'center' });
  const [cat, setCat] = useState('Todas');
  hoverRef.current = hover;

  useLayoutEffect(() => {
    const box = boxRef.current;
    const svg = svgRef.current;
    if (!box || !svg) return undefined;
    const reduce = reducedMotion();
    const rings = [NET_TOOLS.filter(t => t.ring === 0), NET_TOOLS.filter(t => t.ring === 1)];
    let W = 0; let H = 0; let raf = 0; let running = false;
    let last = performance.now(); let rot = 0; let speed = 1;

    const measure = () => {
      W = box.clientWidth;
      H = box.clientHeight;
      svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
    };

    const layout = (now) => {
      const cx = W / 2;
      const cy = H / 2;
      const narrow = W < 640;
      const geo = [
        { rx: W * (narrow ? 0.29 : 0.235), ry: H * (narrow ? 0.2 : 0.29), dir: 1, off: -Math.PI / 2, par: 6 },
        { rx: W * (narrow ? 0.4 : 0.425), ry: H * (narrow ? 0.41 : 0.41), dir: -0.7, off: -Math.PI / 2 + Math.PI / 8, par: 14 },
      ];
      rings.forEach((list, ri) => {
        const g = geo[ri];
        list.forEach((tool, i) => {
          const a = g.off + (i / list.length) * Math.PI * 2 + rot * g.dir;
          const x = cx + g.rx * Math.cos(a) + pointer.current.x * g.par;
          const y = cy + g.ry * Math.sin(a) + pointer.current.y * g.par;
          const el = nodes.current[tool.id];
          if (el) el.style.transform = `translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0) translate(-50%,-50%)`;
          ['a', 'b'].forEach(k => {
            const ln = links.current[tool.id + k];
            if (!ln) return;
            ln.setAttribute('x1', cx); ln.setAttribute('y1', cy);
            ln.setAttribute('x2', x.toFixed(1)); ln.setAttribute('y2', y.toFixed(1));
          });
          const p = pulses.current[tool.id];
          if (p) {
            // Datos que viajan: la órbita interna hacia Talku, la externa desde Talku.
            const ph = ((now / 2600) + i * 0.37 + ri * 0.5) % 1;
            const k = ri === 0 ? ph : 1 - ph;
            p.setAttribute('cx', (x + (cx - x) * k).toFixed(1));
            p.setAttribute('cy', (y + (cy - y) * k).toFixed(1));
            p.setAttribute('opacity', reduce ? '0' : Math.sin(ph * Math.PI).toFixed(2));
          }
        });
      });
    };

    const tick = (now) => {
      const dt = Math.min(64, now - last);
      last = now;
      speed += ((hoverRef.current ? 0 : 1) - speed) * 0.06;
      rot += dt * 0.00005 * speed;
      layout(now);
      raf = requestAnimationFrame(tick);
    };
    const start = () => { if (running || reduce) return; running = true; last = performance.now(); raf = requestAnimationFrame(tick); };
    const stop = () => { running = false; cancelAnimationFrame(raf); };

    measure();
    layout(0);
    const ro = new ResizeObserver(() => { measure(); layout(performance.now()); });
    ro.observe(box);
    let io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(([e]) => (e.isIntersecting ? start() : stop()), { rootMargin: '120px' });
      io.observe(box);
    } else {
      start();
    }
    return () => { stop(); ro.disconnect(); if (io) io.disconnect(); };
  }, []);

  const onMove = (e) => {
    if (e.pointerType !== 'mouse') return;
    const r = boxRef.current.getBoundingClientRect();
    pointer.current = { x: (e.clientX - r.left) / r.width - 0.5, y: (e.clientY - r.top) / r.height - 0.5 };
  };
  const onLeaveBox = () => { pointer.current = { x: 0, y: 0 }; setHover(null); };

  const enter = (id) => {
    const box = boxRef.current;
    const el = nodes.current[id];
    if (box && el) {
      const b = box.getBoundingClientRect();
      const r = el.getBoundingClientRect();
      const fx = (r.left + r.width / 2 - b.left) / b.width;
      const fy = (r.top + r.height / 2 - b.top) / b.height;
      setTip({ below: fy < 0.38, align: fx < 0.26 ? 'left' : fx > 0.74 ? 'right' : 'center' });
    }
    setHover(id);
  };

  const state = (t) => {
    const on = hover === t.id || (!hover && cat !== 'Todas' && t.cat === cat);
    const dim = (hover && hover !== t.id) || (!hover && cat !== 'Todas' && t.cat !== cat);
    return `${on ? ' tl-on' : ''}${dim ? ' tl-dim' : ''}`;
  };

  return (
    <div className="tl-net-wrap">
      <div className="tl-net-cats" role="group" aria-label="Filtrar por categoría">
        {NET_CATS.map(c => (
          <button key={c} type="button" className={`tl-net-cat${cat === c ? ' tl-sel' : ''}`} aria-pressed={cat === c} onClick={() => setCat(c)}>{c}</button>
        ))}
      </div>
      <div className={`tl-net${hover ? ' tl-net-hovering' : ''}`} ref={boxRef} onPointerMove={onMove} onPointerLeave={onLeaveBox}>
        <svg ref={svgRef} className="tl-net-svg" aria-hidden="true">
          {NET_TOOLS.map(t => (
            <g key={t.id} className={`tl-net-link${state(t)}`}>
              <line ref={el => { links.current[t.id + 'a'] = el; }} className="tl-net-base" />
              <line ref={el => { links.current[t.id + 'b'] = el; }} className="tl-net-flow" />
              <circle ref={el => { pulses.current[t.id] = el; }} r="3.2" className="tl-net-pulse" />
            </g>
          ))}
        </svg>
        <div className="tl-net-hub">
          <span className="tl-net-ring" />
          <span className="tl-net-ring tl-net-ring-2" />
          <div className="tl-net-core tl-glass"><img src="/logo-talku.png" alt="Talku" /></div>
        </div>
        {NET_TOOLS.map((t, i) => (
          <button
            key={t.id}
            type="button"
            ref={el => { nodes.current[t.id] = el; }}
            className={`tl-net-node${state(t)}`}
            style={{ '--d': `${200 + i * 60}ms` }}
            aria-label={`${t.name}: ${t.desc}`}
            onMouseEnter={() => enter(t.id)}
            onMouseLeave={() => setHover(null)}
            onFocus={() => enter(t.id)}
            onBlur={() => setHover(null)}
            onClick={() => enter(t.id)}
          >
            <span className="tl-net-ico">{t.icon}</span>
            <span className="tl-net-name">{t.name}</span>
            {hover === t.id && (
              <span className={`tl-net-tip tl-tip-${tip.align}${tip.below ? ' tl-tip-below' : ''}`}>
                <small>{t.cat}</small>
                <b>{t.name}</b>
                <span>{t.desc}</span>
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

// ── Mini interfaces (ilustrativas) ───────────────────────────────
function MiniSales() {
  return (
    <div className="tl-ui">
      <div className="tl-ui-top"><span className="tl-ui-label">Ventas del mes</span><span className="tl-live"><i />En vivo</span></div>
      <div className="tl-ui-big"><CountUp to={24850000} prefix="$" /></div>
      <AreaChart id="sales" points={[30, 38, 34, 46, 42, 55, 51, 63, 60, 74, 70, 86]} />
    </div>
  );
}

const CHANNEL = { wa: ['#25d366', 'WA'], ig: ['#e1306c', 'IG'], fb: ['#0084ff', 'FB'] };

function MiniInbox() {
  const rows = [
    { ch: 'wa', name: 'María G.', msg: '¿Tienen envío a Cali?', who: 'IA', unread: true },
    { ch: 'ig', name: 'Andrés P.', msg: 'Quiero la talla 40', who: 'Laura', unread: true },
    { ch: 'fb', name: 'Camila R.', msg: '¡Gracias, ya llegó!', who: 'Juan', unread: false },
  ];
  return (
    <div className="tl-ui">
      <div className="tl-ui-top"><span className="tl-ui-label">Bandeja unificada</span><span className="tl-ui-muted">3 canales</span></div>
      <div className="tl-inbox">
        {rows.map((r, i) => (
          <div className="tl-inbox-row" key={r.name} style={{ '--d': `${250 + i * 160}ms` }}>
            <span className="tl-ch" style={{ background: CHANNEL[r.ch][0] }}>{CHANNEL[r.ch][1]}</span>
            <div className="tl-inbox-txt"><b>{r.name}</b><span>{r.msg}</span></div>
            <span className="tl-who">{r.who}</span>
            {r.unread && <i className="tl-unread" />}
          </div>
        ))}
      </div>
    </div>
  );
}

function MiniAgent() {
  const bubbles = [
    ['in', 'Hola, ¿me llega a Pereira?'],
    ['out', '¡Sí! Llega en 2 a 4 días hábiles. ¿Confirmo tu pedido contra entrega?'],
    ['in', 'Sí, por favor 🙌'],
  ];
  return (
    <div className="tl-ui">
      <div className="tl-ui-top"><span className="tl-ui-label">Agente IA</span><span className="tl-live"><i />Activo 24/7</span></div>
      <div className="tl-bubbles">
        {bubbles.map(([who, t], i) => (
          <div key={i} className={`tl-bub tl-bub-${who}`} style={{ '--d': `${300 + i * 700}ms` }}>{t}</div>
        ))}
      </div>
    </div>
  );
}

function MiniTracking() {
  const steps = ['Pedido confirmado', 'Pago verificado', 'Guía generada', 'En reparto'];
  return (
    <div className="tl-ui">
      <div className="tl-ui-top"><span className="tl-ui-label">Pedido #1045</span><span className="tl-pill-soft">Coordinadora</span></div>
      <div className="tl-track">
        {steps.map((t, i) => (
          <div className={`tl-track-step${i === steps.length - 1 ? ' tl-active' : ' tl-done'}`} key={t} style={{ '--d': `${300 + i * 450}ms` }}>
            <span className="tl-track-dot"><Icon name="check" size={12} /></span>{t}
          </div>
        ))}
      </div>
    </div>
  );
}

function MiniPayments() {
  const rows = [['Contra entrega', 'Confirmado', 'ok'], ['ADDI', 'Aprobado', 'ok'], ['Wompi', 'Pendiente', 'wait'], ['Sistecrédito', 'Recuperado', 'ok']];
  return (
    <div className="tl-ui">
      <div className="tl-ui-top"><span className="tl-ui-label">Pagos</span><span className="tl-ui-muted">Hoy</span></div>
      <div className="tl-pay">
        {rows.map(([m, s, k], i) => (
          <div className="tl-pay-row" key={m} style={{ '--d': `${250 + i * 140}ms` }}>
            <span>{m}</span><span className={`tl-status tl-status-${k}`}>{s}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function MiniCampaign() {
  const bars = [['Enviados', 100], ['Entregados', 96], ['Leídos', 71]];
  return (
    <div className="tl-ui">
      <div className="tl-ui-top"><span className="tl-ui-label">Campaña · Nuevos productos</span></div>
      <div className="tl-bars">
        {bars.map(([l, v], i) => (
          <div key={l}>
            <div className="tl-bars-lbl"><span>{l}</span><b>{v}%</b></div>
            <div className="tl-bars-track"><div style={{ '--w': `${v}%`, '--d': `${300 + i * 220}ms` }} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}

function MiniAgentSteps() {
  const steps = [
    ['Entendiendo la pregunta', 'El cliente pregunta por talla y envío'],
    ['Consultando el catálogo', 'Talla 38 disponible en negro y blanco'],
    ['Cotizando el envío', 'Destino: Medellín'],
    ['Creando el pedido', 'Contra entrega'],
  ];
  const [active, setActive] = useState(() => (reducedMotion() ? steps.length : 0));
  useEffect(() => {
    if (reducedMotion()) return undefined;
    const id = setInterval(() => setActive(a => (a + 1) % (steps.length + 2)), 1500);
    return () => clearInterval(id);
  }, [steps.length]);
  return (
    <div className="tl-ui tl-ui-lg">
      <div className="tl-ui-top">
        <span className="tl-ui-label">{active >= steps.length ? 'Pedido creado ✓' : 'Talku IA está atendiendo…'}</span>
      </div>
      <div className="tl-asteps">
        {steps.map(([t, d], i) => {
          const st = i < active ? 'done' : i === active ? 'active' : 'todo';
          return (
            <div className={`tl-astep tl-${st}`} key={t}>
              <span className="tl-astep-ico">{st === 'done' ? <Icon name="check" size={14} /> : <i />}</span>
              <div><b>{t}</b><span>{d}</span></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function MiniDashboard() {
  const states = [['Por confirmar', 12], ['Por pagar', 5], ['Listos para guía', 8], ['En camino', 23]];
  return (
    <div className="tl-ui tl-ui-lg">
      <div className="tl-ui-top"><span className="tl-ui-label">Pedidos de la semana</span><span className="tl-live"><i />En vivo</span></div>
      <div className="tl-ui-big"><CountUp to={148} /> <small>pedidos</small></div>
      <AreaChart id="dash" height={120} points={[20, 28, 26, 40, 36, 48, 45, 58, 66, 62, 78, 84]} />
      <div className="tl-states">
        {states.map(([l, n]) => <div key={l}><b><CountUp to={n} duration={1200} /></b><span>{l}</span></div>)}
      </div>
    </div>
  );
}

// ── Funciones apiladas ───────────────────────────────────────────
// Cada tarjeta es sticky: al hacer scroll la siguiente se monta encima y la de atrás
// se encoge y se oscurece según cuánto la cubren las siguientes (efecto "pila de cartas").
const FEATURE_STACK = [
  { kicker: 'Dashboard', theme: 'light', ui: <MiniSales />,
    title: 'Mira cómo se mueven tus ventas en tiempo real',
    text: 'Ventas, pedidos y productos más vendidos en un dashboard que se actualiza solo.',
    points: ['Ventas y pedidos en vivo', 'Productos más vendidos', 'Pedidos por estado'] },
  { kicker: 'Bandeja unificada', theme: 'dark', ui: <MiniInbox />,
    title: 'Todos tus chats en una sola bandeja',
    text: 'WhatsApp, Instagram y Messenger juntos, con cada conversación asignada al asesor correcto.',
    points: ['WhatsApp, Instagram y Messenger', 'Asignación por asesor', 'Etiquetas y estados'] },
  { kicker: 'Inteligencia artificial', theme: 'lime', ui: <MiniAgent />,
    title: 'Una IA que responde y toma pedidos 24/7',
    text: 'Tu agente conoce tu catálogo, cotiza el envío y confirma el pedido mientras duermes.',
    points: ['Atiende a cualquier hora', 'Cotiza envíos por ciudad', 'Crea el pedido desde el chat'] },
  { kicker: 'Logística', theme: 'light', ui: <MiniTracking />,
    title: 'Del chat a la entrega, sin salir de Talku',
    text: 'Genera la guía, avisa a bodega y sigue cada envío con la transportadora.',
    points: ['Guía y rótulo en un clic', 'Aviso a bodega por WhatsApp', 'Rastreo y novedades'] },
  { kicker: 'Pagos', theme: 'dark', ui: <MiniPayments />,
    title: 'Cada pago bajo control',
    text: 'Contra entrega o financiado: sigue el estado de cada pago y recupera los que fallan.',
    points: ['Contra entrega', 'ADDI, Sistecrédito, Wompi, MercadoPago y Openpay', 'Recuperación de pagos fallidos'] },
  { kicker: 'Campañas', theme: 'lime', ui: <MiniCampaign />,
    title: 'Vuelve a venderle a tus clientes',
    text: 'Campañas por WhatsApp y email a tus audiencias, y recuperación de carritos abandonados.',
    points: ['WhatsApp y email', 'Audiencias', 'Carritos abandonados'] },
];

function StackedFeatures() {
  const cards = useRef([]);

  useEffect(() => {
    if (reducedMotion()) return undefined;
    let raf = 0;
    const update = () => {
      raf = 0;
      const list = cards.current.filter(Boolean);
      // top + offsetHeight: con transform-origin arriba, la escala no mueve el borde superior.
      const box = list.map(c => {
        const top = c.getBoundingClientRect().top;
        return { top, bottom: top + c.offsetHeight, h: c.offsetHeight };
      });
      list.forEach((c, i) => {
        let depth = 0;
        for (let j = i + 1; j < list.length; j++) {
          depth += Math.max(0, Math.min(1, (box[i].bottom - box[j].top) / box[i].h));
        }
        c.style.setProperty('--s', (1 - depth * 0.045).toFixed(4));
        c.style.setProperty('--dim', Math.min(0.55, depth * 0.2).toFixed(3));
      });
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="tl-stack">
      {FEATURE_STACK.map((f, i) => (
        <div className="tl-stack-item" key={f.title} style={{ '--i': i }}>
          <article
            ref={el => { cards.current[i] = el; }}
            className={`tl-stack-card tl-stack-${f.theme}`}
            data-reveal="custom"
          >
            <div className="tl-stack-copy">
              <div className="tl-stack-meta">
                <span className="tl-stack-num">{String(i + 1).padStart(2, '0')}</span>
                <span className="tl-stack-kicker">{f.kicker}</span>
              </div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
              <ul>
                {f.points.map(p => <li key={p}><span><Icon name="check" size={13} /></span>{p}</li>)}
              </ul>
            </div>
            <div className="tl-stack-ui">{f.ui}</div>
          </article>
        </div>
      ))}
    </div>
  );
}

// ── Ecosistema: réplicas de la plataforma (datos de prueba) ──────
// Clases "ap-" = copia del sistema visual real de cada módulo:
//   Dashboard.js (db-*), Conversations.js (conv-*/msg-*), Orders.js (tw-*/badge + ESTADO_CONFIG).
// Se diseñan en un lienzo fijo de 560×392 (el alto está en el CSS) y se escalan con --k.
const APP_W = 560;

const AP_ESTADO = {
  sin_confirmar: { label: 'Sin confirmar', color: '#d97706', bg: '#fffbeb' },
  por_generar: { label: 'Por generar', color: '#ea580c', bg: '#fff7ed' },
  despachado: { label: 'Despachado', color: '#3b82f6', bg: '#eff6ff' },
  entregado: { label: 'Entregado', color: '#16a34a', bg: '#f0fdf4' },
};

function AppTopbar({ active }) {
  return (
    <div className="ap-top">
      <div className="ap-brand"><img src="/talku-symbol.png" alt="" /><b>Talku</b></div>
      <div className="ap-nav">
        {['Dashboard', 'Conversaciones', 'Pedidos'].map(n => (
          <span key={n} className={n === active ? 'ap-nav-on' : undefined}>{n}</span>
        ))}
      </div>
      <div className="ap-prof"><i>L</i></div>
    </div>
  );
}

function AppDashboard() {
  const kpis = [
    { label: 'Ventas hoy', value: '$6.240.000', trend: '▲ 12% vs ayer', tone: 'lav' },
    { label: 'Pedidos hoy', value: '48', trend: '▲ 8% vs ayer', tone: 'blue' },
    { label: 'Conversaciones activas', value: '23', trend: 'en este momento', tone: 'green', flat: true },
  ];
  const pipe = [['Nuevos', 18, 'lav'], ['Confirmados', 31, 'green'], ['Despachados', 26, 'blue'], ['Entregados', 42, 'green'], ['Novedades', 4, 'amber']];
  const rev = [30, 42, 38, 55, 50, 68, 74];
  const ord = [26, 30, 35, 40, 44, 52, 60];
  const W = 300; const H = 86;
  const pts = arr => arr.map((v, i) => `${(i / (arr.length - 1)) * W},${H - (v / 100) * H}`).join(' ');
  return (
    <div className="ap-screen ap-db">
      <AppTopbar active="Dashboard" />
      <div className="ap-db-in">
        <div className="ap-db-head">
          <div>
            <div className="ap-db-greet">Buenos días, Laura</div>
            <div className="ap-db-sub">Hoy: 48 pedidos · $6.240.000 · 23 conversaciones activas</div>
          </div>
          <div className="ap-pills"><span className="ap-pill-on">Día</span><span>Semana</span><span>Mes</span></div>
        </div>
        <div className="ap-kpis">
          {kpis.map(k => (
            <div className="ap-card ap-kpi" key={k.label}>
              <i className={`ap-kpi-ic ${k.tone}`} />
              <div className="ap-kpi-lbl">{k.label}</div>
              <div className="ap-kpi-val">{k.value}</div>
              <div className={`ap-kpi-tr${k.flat ? '' : ' up'}`}>{k.trend}</div>
            </div>
          ))}
        </div>
        <div className="ap-db-grid">
          <div className="ap-card">
            <div className="ap-ct"><b>Evolución</b><span>Semana</span></div>
            <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className="ap-line-svg" aria-hidden="true">
              {[0.25, 0.5, 0.75].map(g => <line key={g} x1="0" x2={W} y1={H * g} y2={H * g} className="ap-grid" />)}
              <polygon points={`0,${H} ${pts(rev)} ${W},${H}`} className="ap-area" />
              <polyline points={pts(rev)} className="ap-line ap-line-rev" pathLength="1" />
              <polyline points={pts(ord)} className="ap-line ap-line-ord" pathLength="1" />
            </svg>
            <div className="ap-x">{['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map(d => <span key={d}>{d}</span>)}</div>
          </div>
          <div className="ap-card">
            <div className="ap-ct"><b>Pipeline de pedidos</b></div>
            {pipe.map(([n, v, t], i) => (
              <div className="ap-row" key={n}>
                <span className="ap-row-n">{n}</span>
                <span className="ap-track"><span className={`ap-fill ${t}`} style={{ '--w': `${(v / 42) * 100}%`, '--d': `${i * 90}ms` }} /></span>
                <span className="ap-row-v">{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function AppConversations() {
  const AV = ['#6ee7b7', '#93c5fd', '#fca5a5', '#fcd34d'];
  const chats = [
    { n: 'María Gómez', p: '¿Me llega a Pereira?', t: '10:42', u: 2, on: true },
    { n: 'Andrés Pérez', p: 'Quiero la talla 40', t: '10:31', u: 1 },
    { n: 'Camila Ríos', p: '¡Gracias, ya llegó! 🙌', t: '09:58' },
    { n: 'Juan Torres', p: '¿Aceptan ADDI?', t: '09:40' },
  ];
  const ini = n => n.split(' ').map(w => w[0]).join('').slice(0, 2);
  return (
    <div className="ap-screen ap-cv">
      <AppTopbar active="Conversaciones" />
      <div className="ap-cv-in">
        <div className="ap-cv-list">
          <div className="ap-cv-h"><b>Chats</b><span className="ap-cv-new">+ Nuevo</span></div>
          <div className="ap-cv-search">Buscar conversación</div>
          <div className="ap-cv-tabs"><span className="ap-tab-on">Todos</span><span>No leídos</span><span>Míos</span></div>
          {chats.map((c, i) => (
            <div className={`ap-ci${i === 0 ? ' ap-ci-on' : ''}`} key={c.n} style={{ '--d': `${i * 80}ms` }}>
              <div className="ap-ci-av" style={{ background: AV[i] }}>{ini(c.n)}{c.on && <i />}</div>
              <div className="ap-ci-body">
                <div className="ap-ci-top"><b>{c.n}</b><time>{c.t}</time></div>
                <div className="ap-ci-bot"><span>{c.p}</span>{c.u && <em>{c.u}</em>}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="ap-cv-chat">
          <div className="ap-ch">
            <div className="ap-ch-av" style={{ background: AV[0] }}>MG<i /></div>
            <div><b>María Gómez</b><span>WhatsApp · Asignado a Laura</span></div>
          </div>
          <div className="ap-msgs">
            <span className="ap-date">Hoy</span>
            <div className="ap-bub in" style={{ '--d': '100ms' }}>Hola, ¿tienen las zapatillas en talla 38?</div>
            <div className="ap-bub out" style={{ '--d': '400ms' }}>¡Hola María! Sí, en negro y en blanco 👟</div>
            <div className="ap-bub in" style={{ '--d': '700ms' }}>¿Me llega a Pereira?</div>
            <div className="ap-bub out" style={{ '--d': '1000ms' }}>Sí, en 2 a 4 días hábiles. ¿Confirmo contra entrega?</div>
          </div>
          <div className="ap-input"><span>Escribe un mensaje…</span><i /></div>
        </div>
      </div>
    </div>
  );
}

function AppOrders() {
  const PT = ['#e0e7ff', '#fde68a', '#fbcfe8', '#bbf7d0'];
  const rows = [
    { id: '#1045', c: 'Laura Gómez', p: 'Tenis Urban Pro', s: 'Negro · 38', v: '$189.900', m: 'Contraentrega / COD', e: 'sin_confirmar' },
    { id: '#1044', c: 'Andrés Pérez', p: 'Reloj Classic', s: 'Plateado', v: '$249.000', m: 'ADDI', e: 'por_generar' },
    { id: '#1043', c: 'Camila Ríos', p: 'Set Skincare x3', s: 'Kit completo', v: '$132.500', m: 'Wompi', e: 'despachado' },
    { id: '#1042', c: 'Juan Torres', p: 'Audífonos Air', s: 'Blanco', v: '$159.900', m: 'Contraentrega / COD', e: 'entregado' },
  ];
  return (
    <div className="ap-screen ap-or">
      <AppTopbar active="Pedidos" />
      <div className="ap-or-in">
        <div className="ap-or-title">Pedidos</div>
        <div className="ap-or-sub">128 pedidos · últimos 7 días</div>
        <div className="ap-fbar">
          {[['Todos', 128], ['Sin confirmar', 12], ['Por generar', 8], ['Despachado', 31], ['Entregado', 64]].map(([t, n], i) => (
            <span key={t} className={i === 0 ? 'ap-otab ap-otab-on' : 'ap-otab'}>{t}<em>{n}</em></span>
          ))}
        </div>
        <div className="ap-tw">
          <div className="ap-tw-h"><span>Pedido</span><span>Cliente</span><span>Producto</span><span>Valor</span><span>Estado</span></div>
          {rows.map((r, i) => {
            const e = AP_ESTADO[r.e];
            return (
              <div className="ap-tw-r" key={r.id} style={{ '--d': `${i * 90}ms` }}>
                <span className="ap-tw-id">{r.id}<i /></span>
                <span className="ap-tw-c">{r.c}</span>
                <span className="ap-tw-p"><i style={{ background: PT[i] }}>{r.p[0]}</i><span><b>{r.p}</b><small>{r.s}</small></span></span>
                <span className="ap-tw-v"><b>{r.v}</b><small>{r.m}</small></span>
                <span><em className="ap-badge" style={{ background: e.bg, color: e.color }}><i style={{ background: e.color }} />{e.label}</em></span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const ECO_CARDS = [
  { id: 'dashboard', label: 'Dashboard', screen: <AppDashboard /> },
  { id: 'conversaciones', label: 'Conversaciones', screen: <AppConversations /> },
  { id: 'pedidos', label: 'Pedidos', screen: <AppOrders /> },
];

// Abanico de tarjetas: tocar la de adelante la manda al fondo; tocar una de atrás la trae adelante.
// Avanza solo cada pocos segundos mientras está visible, y se pausa con el mouse encima.
function EcoStack() {
  const stageRef = useRef(null);
  const timer = useRef(0);
  const busy = useRef(false);
  const visible = useRef(false);
  const [order, setOrder] = useState(ECO_CARDS.map(c => c.id));
  const [leaving, setLeaving] = useState(null);
  const [paused, setPaused] = useState(false);
  const orderRef = useRef(order);
  orderRef.current = order;

  const next = () => {
    if (busy.current) return;
    busy.current = true;
    setLeaving(orderRef.current[0]);
    timer.current = setTimeout(() => {
      setOrder(o => [...o.slice(1), o[0]]);
      setLeaving(null);
      busy.current = false;
    }, 420);
  };
  const nextRef = useRef(next);
  nextRef.current = next;

  const bringToFront = (id) => {
    if (busy.current) return;
    setOrder(o => { const i = o.indexOf(id); return i <= 0 ? o : [...o.slice(i), ...o.slice(0, i)]; });
  };

  // Escala del lienzo según el ancho disponible.
  useLayoutEffect(() => {
    const el = stageRef.current;
    if (!el) return undefined;
    const fit = () => {
      const fan = el.clientWidth < 420 ? 14 : 22;
      const k = Math.max(0.4, (el.clientWidth - fan * 2) / APP_W);
      el.style.setProperty('--k', k.toFixed(4));
      el.style.setProperty('--fan', `${fan}px`);
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const el = stageRef.current;
    if (!el || !('IntersectionObserver' in window)) return undefined;
    const io = new IntersectionObserver(([e]) => { visible.current = e.isIntersecting; }, { threshold: 0.35 });
    io.observe(el);
    return () => { io.disconnect(); clearTimeout(timer.current); };
  }, []);

  useEffect(() => {
    if (paused || reducedMotion()) return undefined;
    const id = setInterval(() => { if (visible.current && !document.hidden) nextRef.current(); }, 5200);
    return () => clearInterval(id);
  }, [paused]);

  const activate = (id) => (orderRef.current[0] === id ? next() : bringToFront(id));

  return (
    <div className="tl-eco" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <div className="tl-eco-stage" ref={stageRef}>
        {ECO_CARDS.map(c => {
          const k = order.indexOf(c.id);
          return (
            <div
              key={c.id}
              role="button"
              tabIndex={k === 0 ? 0 : -1}
              aria-label={k === 0 ? `${c.label}: toca para ver la siguiente` : `Ver ${c.label}`}
              className={`tl-eco-card${k === 0 ? ' tl-front' : ''}${leaving === c.id ? ' tl-out' : ''}`}
              style={{ '--p': k, zIndex: 10 - k }}
              onClick={() => activate(c.id)}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(c.id); } }}
            >
              <div className="tl-eco-canvas">{c.screen}</div>
            </div>
          );
        })}
      </div>
      <div className="tl-eco-nav">
        {ECO_CARDS.map(c => (
          <button key={c.id} type="button" className={`tl-eco-dot${order[0] === c.id ? ' tl-sel' : ''}`} onClick={() => bringToFront(c.id)}>{c.label}</button>
        ))}
      </div>
      <p className="tl-eco-hint"><Icon name="hand" size={15} />Toca las tarjetas para alternar</p>
    </div>
  );
}

// ── Estilos ──────────────────────────────────────────────────────
const LANDING_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700;800&display=swap');
.tl-root{--ink:#0b0b0b;--ink2:#262626;--muted:#6b7280;--soft:#a1a1aa;--line:#ececea;--bg:#ffffff;--card:#f4f4f2;
  --lime:#a3e31c;--lime2:#84cc16;--lime-d:#3f6212;--lime-t:#f1fbdc;
  --spring:cubic-bezier(.34,1.56,.64,1);--ease:cubic-bezier(.2,.8,.2,1);
  font-family:'Inter Tight','SF Pro Display',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
  color:var(--ink);background:var(--bg);min-height:100vh;overflow-x:hidden;overflow-x:clip;-webkit-font-smoothing:antialiased}
.tl-root *{box-sizing:border-box}
:where(.tl-root) a{text-decoration:none;color:inherit}
.tl-root section[id]{scroll-margin-top:100px}
.tl-wrap{max-width:1180px;margin:0 auto;padding:0 24px}

/* ── Vidrio líquido ── */
.tl-glass{position:relative;isolation:isolate;background:var(--gl-tint,rgba(255,255,255,.55));
  -webkit-backdrop-filter:blur(var(--gl-blur,18px)) saturate(180%);backdrop-filter:blur(var(--gl-blur,18px)) saturate(180%);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.95),inset 0 -1px 0 rgba(255,255,255,.35),inset 1px 0 0 rgba(255,255,255,.4),inset -1px 0 0 rgba(255,255,255,.4),
    inset 0 0 18px rgba(255,255,255,.35),0 14px 36px -12px rgba(0,0,0,.22),0 2px 8px rgba(0,0,0,.05)}
.tl-glass>*{position:relative;z-index:2}
.tl-glass:after{content:'';position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:1;padding:1px;
  background:linear-gradient(155deg,rgba(255,255,255,.95) 0%,rgba(255,255,255,.1) 30%,rgba(255,255,255,0) 60%,rgba(255,255,255,.5) 100%);
  -webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude}
.tl-glass:before{content:'';position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:1;
  background:radial-gradient(160px circle at var(--mx,50%) var(--my,-60%),rgba(255,255,255,.6),rgba(255,255,255,0) 65%);
  opacity:0;transition:opacity .4s}
.tl-glass:hover:before{opacity:1}
.tl-glass-dark{--gl-tint:rgba(14,14,14,.84);color:#fff;
  box-shadow:inset 0 1px 0 rgba(255,255,255,.28),inset 0 -1px 0 rgba(255,255,255,.08),inset 0 0 14px rgba(255,255,255,.06),
    0 14px 30px -10px rgba(0,0,0,.45),0 2px 6px rgba(0,0,0,.15)}
.tl-glass-dark:after{background:linear-gradient(155deg,rgba(255,255,255,.45) 0%,rgba(255,255,255,0) 35%,rgba(255,255,255,0) 65%,rgba(255,255,255,.2) 100%)}
.tl-glass-dark:before{background:radial-gradient(140px circle at var(--mx,50%) var(--my,-60%),rgba(163,227,28,.45),rgba(163,227,28,0) 65%)}
.tl-refracting{--gl-tint:rgba(255,255,255,.34)}
.tl-refracting.tl-glass-dark{--gl-tint:rgba(14,14,14,.78)}

/* ── Botones ── */
.tl-btn{--tx:0px;--ty:0px;--sc:1;display:inline-flex;align-items:center;justify-content:center;gap:8px;height:46px;padding:0 22px;border-radius:999px;
  font-size:15px;font-weight:600;white-space:nowrap;cursor:pointer;border:0;color:var(--ink);
  transform:translate3d(var(--tx),var(--ty),0) scale(var(--sc));transition:transform .55s var(--spring),box-shadow .3s,background-color .3s}
.tl-btn.tl-glass-dark,.tl-btn.tl-glass-dark span{color:#fff}
.tl-btn:hover{--sc:1.035}
.tl-btn:active{--sc:.94;transition-duration:.15s}
.tl-btn svg{transition:transform .45s var(--spring)}
.tl-btn:hover svg{transform:translateX(3px)}
.tl-btn-lg{height:54px;padding:0 28px;font-size:16px}
.tl-btn-sm{height:40px;padding:0 16px;font-size:14px}
.tl-btn-text{background:transparent;color:var(--ink);padding:0 14px}
.tl-btn-text:hover{background:rgba(0,0,0,.05)}
.tl-btn:focus-visible{outline:2px solid var(--lime2);outline-offset:3px}

/* ── Header fijo ── */
.tl-nav{position:fixed;top:14px;left:0;right:0;z-index:100;padding:0 16px;pointer-events:none}
.tl-bar{pointer-events:auto;max-width:1180px;margin:0 auto;height:64px;border-radius:999px;padding:0 10px 0 22px;display:flex;align-items:center;justify-content:space-between;gap:16px;
  transition:height .45s var(--ease),box-shadow .4s;animation:tl-drop .9s var(--spring) both}
.tl-nav.tl-solid .tl-bar{height:58px}
.tl-brand img{height:26px;width:auto;display:block;transition:transform .45s var(--spring)}
.tl-brand:hover img{transform:scale(1.04)}
.tl-links{position:relative;display:flex;align-items:center;gap:2px}
.tl-links a{position:relative;z-index:2;padding:9px 14px;border-radius:999px;font-size:15px;font-weight:500;color:#3f3f46;transition:color .25s}
.tl-links a:hover,.tl-links a.tl-on{color:var(--ink)}
.tl-ind{position:absolute;z-index:1;top:50%;left:0;height:38px;border-radius:999px;pointer-events:none;opacity:0;
  background:rgba(255,255,255,.75);box-shadow:inset 0 1px 0 #fff,0 4px 14px rgba(0,0,0,.08),inset 0 0 0 1px rgba(0,0,0,.04);
  transform:translate3d(var(--ix,0),-50%,0);width:var(--iw,0);transition:transform .55s var(--spring),width .55s var(--spring),opacity .3s}
.tl-ind.tl-ind-on{opacity:1}
.tl-actions{display:flex;align-items:center;gap:6px}
.tl-prog{position:absolute;z-index:3;left:26px;right:26px;bottom:0;height:2px;border-radius:2px;background:var(--lime2);
  transform-origin:left;transform:scaleX(var(--prog,0));opacity:.9}
.tl-burger{display:none;width:44px;height:44px;border-radius:50%;border:0;background:transparent;cursor:pointer;align-items:center;justify-content:center;color:var(--ink)}
.tl-burger span{position:relative;display:block;width:18px;height:2px;border-radius:2px;background:currentColor;transition:background .2s}
.tl-burger span:before,.tl-burger span:after{content:'';position:absolute;left:0;width:18px;height:2px;border-radius:2px;background:currentColor;transition:transform .45s var(--spring)}
.tl-burger span:before{transform:translateY(-6px)}
.tl-burger span:after{transform:translateY(6px)}
.tl-burger.tl-x span{background:transparent}
.tl-burger.tl-x span:before{transform:rotate(45deg)}
.tl-burger.tl-x span:after{transform:rotate(-45deg)}
.tl-mobile{pointer-events:auto;max-width:1180px;margin:10px auto 0;border-radius:28px;padding:10px;display:none;
  transform-origin:top center;animation:tl-menu .5s var(--spring) both}
.tl-mobile a.tl-mlink{display:block;padding:14px 16px;border-radius:16px;font-size:17px;font-weight:600}
.tl-mobile a.tl-mlink:active{background:rgba(0,0,0,.05)}
.tl-mobile-btns{display:flex;gap:8px;padding:8px 6px 6px}
.tl-mobile-btns .tl-btn{flex:1}
@keyframes tl-drop{from{opacity:0;transform:translateY(-24px) scale(.96)}}
@keyframes tl-menu{from{opacity:0;transform:translateY(-10px) scale(.96)}}

/* ── Portada ── */
.tl-hero{position:relative;padding:132px 0 32px;overflow:hidden}
.tl-blob{position:absolute;border-radius:50%;filter:blur(60px);opacity:.55;pointer-events:none;z-index:0}
.tl-blob-1{width:520px;height:520px;left:-160px;top:40px;background:radial-gradient(circle,#d9f99d,transparent 70%);animation:tl-drift 16s ease-in-out infinite alternate}
.tl-blob-2{width:420px;height:420px;left:28%;top:320px;background:radial-gradient(circle,#ecfccb,transparent 70%);animation:tl-drift 20s ease-in-out -6s infinite alternate-reverse}
@keyframes tl-drift{0%{transform:translate(0,0) scale(1)}50%{transform:translate(60px,-30px) scale(1.12)}100%{transform:translate(-30px,40px) scale(.95)}}
.tl-hero-grid{position:relative;z-index:1;display:grid;grid-template-columns:1fr 1.05fr;gap:44px;align-items:center}
.tl-eyebrow-pill{display:inline-flex;align-items:center;gap:8px;padding:7px 14px 7px 10px;border-radius:999px;font-size:13px;font-weight:600;color:var(--lime-d);margin-bottom:22px;
  animation:tl-rise .8s var(--ease) both}
.tl-eyebrow-pill i{width:8px;height:8px;border-radius:50%;background:var(--lime2);box-shadow:0 0 0 0 rgba(132,204,22,.6);animation:tl-ping 2s infinite}
@keyframes tl-ping{0%{box-shadow:0 0 0 0 rgba(132,204,22,.55)}80%,100%{box-shadow:0 0 0 10px rgba(132,204,22,0)}}
.tl-h1{font-size:clamp(42px,5.8vw,72px);line-height:1.02;letter-spacing:-.045em;font-weight:700;margin:0 0 22px}
.tl-w{display:inline-block;margin-right:.24em;animation:tl-word .9s var(--ease) both;animation-delay:var(--d)}
.tl-w-em{background:linear-gradient(180deg,transparent 62%,rgba(163,227,28,.65) 62%) no-repeat 0 0/0% 100%;padding:0 .04em;
  animation:tl-word .9s var(--ease) both,tl-mark .8s var(--ease) both;animation-delay:var(--d),calc(var(--d) + 700ms)}
@keyframes tl-word{from{opacity:0;transform:translateY(.45em) rotate(2deg);filter:blur(8px)}}
@keyframes tl-mark{to{background-size:100% 100%}}
@keyframes tl-rise{from{opacity:0;transform:translateY(18px);filter:blur(6px)}}
.tl-lead{font-size:clamp(17px,1.6vw,19px);line-height:1.6;color:var(--muted);margin:0 0 32px;max-width:540px;animation:tl-rise .9s var(--ease) .7s both}
.tl-cta{display:flex;flex-wrap:wrap;gap:10px}
.tl-hero .tl-cta{animation:tl-rise .9s var(--ease) .85s both}

.tl-stage{--px:0;--py:0;position:relative;border-radius:34px;min-height:580px;display:flex;align-items:flex-end;justify-content:center;overflow:hidden;padding-top:48px;
  background:radial-gradient(120% 90% at 70% 10%,#e7fbb4 0%,#c6f05a 38%,#a3e31c 70%,#84cc16 100%);background-size:140% 140%;
  animation:tl-stage-in 1.1s var(--ease) .2s both,tl-grad 14s ease-in-out infinite alternate}
@keyframes tl-stage-in{from{opacity:0;transform:scale(.94) translateY(20px);filter:blur(10px)}}
@keyframes tl-grad{0%{background-position:0% 0%}100%{background-position:100% 60%}}
.tl-stage-glow{position:absolute;width:360px;height:360px;border-radius:50%;background:radial-gradient(circle,rgba(255,255,255,.6),transparent 65%);
  left:calc(20% + var(--px) * 60px);top:calc(55% + var(--py) * 60px);transition:left .8s var(--ease),top .8s var(--ease);pointer-events:none}
.tl-phone{position:relative;z-index:1;width:292px;height:548px;border-radius:46px 46px 0 0;background:#0b0b0b;padding:12px 12px 0;
  box-shadow:0 40px 90px rgba(20,40,0,.4),inset 0 0 0 2px #262626;
  translate:calc(var(--px) * -14px) calc(var(--py) * -8px);transition:translate .8s var(--ease);
  animation:tl-phone-in 1.2s var(--spring) .45s both}
@keyframes tl-phone-in{from{transform:translateY(120px)}}
.tl-phone:before{content:'';position:absolute;top:22px;left:50%;width:84px;height:24px;border-radius:14px;background:#0b0b0b;transform:translateX(-50%);z-index:3}
.tl-screen{height:100%;border-radius:36px 36px 0 0;background:#efeae2;overflow:hidden;display:flex;flex-direction:column}
.tl-screen-head{background:#fff;padding:52px 16px 12px;display:flex;align-items:center;gap:10px;border-bottom:1px solid #eee}
.tl-avatar{width:36px;height:36px;border-radius:50%;background:#fff;box-shadow:inset 0 0 0 1px #e8e8e6;display:flex;align-items:center;justify-content:center;flex:none;overflow:hidden}
.tl-avatar img{width:24px;height:24px;display:block;object-fit:contain}
.tl-screen-head b{display:block;font-size:14px}
.tl-screen-head span{font-size:12px;color:#16a34a}
.tl-chat{padding:14px 12px;display:flex;flex-direction:column;gap:8px;transition:opacity .5s,transform .5s var(--ease)}
.tl-chat-out{opacity:0;transform:translateY(-12px)}
.tl-msg{max-width:84%;padding:9px 12px;border-radius:15px;font-size:13px;line-height:1.4;box-shadow:0 1px 1px rgba(0,0,0,.06);animation:tl-pop .5s var(--spring) both}
.tl-msg-in{background:#fff;align-self:flex-start;border-top-left-radius:4px;transform-origin:left bottom}
.tl-msg-out{background:#dcf8c6;align-self:flex-end;border-top-right-radius:4px;transform-origin:right bottom}
@keyframes tl-pop{from{opacity:0;transform:scale(.7) translateY(10px)}}
.tl-typing{display:flex;gap:4px;padding:12px 14px}
.tl-typing i{width:7px;height:7px;border-radius:50%;background:#9ca3af;animation:tl-dot 1.1s infinite}
.tl-typing i:nth-child(2){animation-delay:.15s}
.tl-typing i:nth-child(3){animation-delay:.3s}
@keyframes tl-dot{0%,60%,100%{transform:translateY(0);opacity:.5}30%{transform:translateY(-4px);opacity:1}}
.tl-float{position:absolute;z-index:3;translate:calc(var(--px) * 22px) calc(var(--py) * 16px);transition:translate .8s var(--ease),opacity .5s,scale .7s var(--spring);
  opacity:0;scale:.6}
.tl-float.tl-show{opacity:1;scale:1}
.tl-float-in{display:flex;align-items:center;gap:10px;padding:12px 16px 12px 12px;border-radius:20px;min-width:196px;font-size:13px;animation:tl-bob 5s ease-in-out infinite}
.tl-f2 .tl-float-in{animation-delay:-1.6s}
.tl-f3 .tl-float-in{animation-delay:-3.2s}
@keyframes tl-bob{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
.tl-float b{display:block;font-size:13px}
.tl-float-in div span{color:#4b5563;font-size:12px}
.tl-float-ico{width:34px;height:34px;border-radius:12px;background:var(--ink);color:var(--lime);display:flex;align-items:center;justify-content:center;flex:none}
.tl-f1{top:60px;left:22px}
.tl-f2{top:230px;right:18px}
.tl-f3{bottom:52px;left:30px}

/* ── Integraciones (red interactiva) ── */
.tl-net-sec{padding-top:88px}
.tl-net-cats{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:-18px 0 26px}
.tl-net-cat{height:38px;padding:0 16px;border-radius:999px;border:1px solid var(--line);background:#fff;font:inherit;font-size:14px;font-weight:600;color:#3f3f46;cursor:pointer;
  transition:background .3s,color .3s,border-color .3s,transform .45s var(--spring)}
.tl-net-cat:hover{border-color:#d4d4d0;transform:translateY(-2px)}
.tl-net-cat.tl-sel{background:var(--ink);border-color:var(--ink);color:var(--lime)}
.tl-net{position:relative;height:620px;border-radius:38px;overflow:hidden;isolation:isolate;
  background:radial-gradient(circle at 50% 50%,rgba(163,227,28,.16),rgba(163,227,28,0) 46%),radial-gradient(#e3e3df 1.2px,transparent 1.3px) 0 0/22px 22px,#fafaf8;
  box-shadow:inset 0 0 0 1px var(--line)}
.tl-net:after{content:'';position:absolute;inset:0;pointer-events:none;border-radius:inherit;background:radial-gradient(ellipse at center,transparent 55%,rgba(250,250,248,.9) 100%)}
.tl-net-svg{position:absolute;inset:0;width:100%;height:100%;overflow:visible;z-index:0}
.tl-net-base{stroke:#dcdcd6;stroke-width:1.4;transition:stroke .35s,opacity .35s}
.tl-net-flow{stroke:var(--lime2);stroke-width:2.2;stroke-dasharray:3 9;stroke-linecap:round;opacity:0;animation:tl-dash .9s linear infinite;transition:opacity .35s}
@keyframes tl-dash{to{stroke-dashoffset:-12}}
.tl-net-pulse{fill:var(--lime2);transition:fill .3s}
.tl-net-link.tl-on .tl-net-base{stroke:#c6f05a}
.tl-net-link.tl-on .tl-net-flow{opacity:1}
.tl-net-link.tl-dim .tl-net-base{opacity:.35}
.tl-net-link.tl-dim .tl-net-pulse{fill:#d4d4d0}
.tl-net-hub{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2;display:flex;align-items:center;justify-content:center}
.tl-net-core{display:flex;align-items:center;justify-content:center;width:168px;height:74px;border-radius:24px;--gl-tint:rgba(255,255,255,.78)}
.tl-net-core img{height:26px;width:auto;display:block}
.tl-net-ring{position:absolute;left:50%;top:50%;width:150px;height:150px;margin:-75px 0 0 -75px;border-radius:50%;border:1.5px solid rgba(132,204,22,.55);
  animation:tl-ripple 3.2s var(--ease) infinite;pointer-events:none}
.tl-net-ring-2{animation-delay:1.6s}
@keyframes tl-ripple{0%{transform:scale(.6);opacity:.9}100%{transform:scale(2.3);opacity:0}}
.tl-net-node{position:absolute;left:0;top:0;z-index:3;display:block;padding:0;border:0;background:none;cursor:pointer;will-change:transform;
  transition:opacity .35s;-webkit-tap-highlight-color:transparent}
.tl-net-node:focus-visible{outline:none}
.tl-net-node:focus-visible .tl-net-ico{box-shadow:0 0 0 3px #fff,0 0 0 5px var(--lime2)}
.tl-net-ico{display:flex;align-items:center;justify-content:center;width:62px;height:62px;border-radius:19px;background:#fff;
  box-shadow:0 10px 26px -8px rgba(0,0,0,.16),inset 0 0 0 1px rgba(0,0,0,.05);
  transition:transform .55s var(--spring),box-shadow .35s,scale .8s var(--spring);transition-delay:0s,0s,var(--d,0ms)}
.tl-net-ico svg,.tl-net-ico img{width:32px;height:32px;display:block;object-fit:contain;border-radius:8px}
.tl-net-name{position:absolute;left:50%;top:100%;margin-top:9px;transform:translateX(-50%);white-space:nowrap;font-size:12.5px;font-weight:600;color:#52525b;
  transition:color .3s,opacity .5s;transition-delay:0s,calc(var(--d,0ms) + 200ms)}
.tl-net-node:hover .tl-net-ico,.tl-net-node.tl-on .tl-net-ico{transform:scale(1.16);box-shadow:0 0 0 5px rgba(241,251,220,.95),0 0 0 6.5px var(--lime2),0 18px 36px -10px rgba(0,0,0,.25)}
.tl-net-node.tl-on{z-index:6}
.tl-net-node.tl-on .tl-net-name{color:var(--ink)}
.tl-net-node.tl-dim{opacity:.38}
.tl-js .tl-net-ico{scale:0}
.tl-js .tl-in .tl-net-ico{scale:1}
.tl-js .tl-net-name{opacity:0}
.tl-js .tl-in .tl-net-name{opacity:1}
.tl-js .tl-net-svg{opacity:0;transition:opacity 1.2s var(--ease) .5s}
.tl-js .tl-in .tl-net-svg{opacity:1}
.tl-net-tip{position:absolute;z-index:10;bottom:calc(100% + 16px);left:50%;transform:translateX(-50%);width:250px;padding:14px 16px;border-radius:18px;text-align:left;
  background:rgba(255,255,255,.96);box-shadow:0 24px 48px -16px rgba(0,0,0,.3),inset 0 0 0 1px var(--line);pointer-events:none;
  animation:tl-tip .4s var(--spring) both}
.tl-tip-below{bottom:auto;top:calc(100% + 38px)}
.tl-tip-left{left:-6px;transform:none}
.tl-tip-right{left:auto;right:-6px;transform:none}
@keyframes tl-tip{from{opacity:0;scale:.85}}
.tl-net-tip small{display:inline-block;font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:var(--lime-d);background:var(--lime-t);padding:3px 8px;border-radius:999px;margin-bottom:8px}
.tl-net-tip b{display:block;font-size:15px;margin-bottom:4px}
.tl-net-tip span{display:block;font-size:13px;line-height:1.5;color:var(--muted);font-weight:500}

/* ── Revelado al hacer scroll ── */
.tl-js [data-reveal]:not([data-reveal=custom]):not(.tl-in){opacity:0;transform:translateY(28px);filter:blur(8px)}
/* fill-mode "backwards": al terminar no deja estilos fijos, así los efectos hover siguen funcionando */
.tl-js [data-reveal].tl-in:not([data-reveal=custom]){animation:tl-reveal .9s var(--ease) backwards;animation-delay:var(--d,0ms)}
@keyframes tl-reveal{from{opacity:0;transform:translateY(28px);filter:blur(8px)}to{opacity:1;transform:none;filter:none}}

/* ── Secciones ── */
.tl-sec{padding:100px 0}
.tl-head{max-width:700px;margin:0 auto 54px;text-align:center}
.tl-head-left{margin-left:0;text-align:left}
.tl-kicker{display:inline-block;font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--lime-d);margin:0 0 14px}
.tl-h2{font-size:clamp(32px,4.4vw,52px);line-height:1.04;letter-spacing:-.04em;font-weight:700;margin:0 0 16px}
.tl-sub{font-size:18px;line-height:1.6;color:var(--muted);margin:0}

/* ── Spotlight en tarjetas ── */
.tl-spot{position:relative;overflow:hidden;isolation:isolate}
.tl-spot:before{content:'';position:absolute;inset:0;z-index:0;pointer-events:none;opacity:0;transition:opacity .4s;
  background:radial-gradient(420px circle at var(--mx,50%) var(--my,50%),rgba(163,227,28,.22),transparent 60%)}
.tl-spot:hover:before{opacity:1}
.tl-spot>*{position:relative;z-index:1}

/* ── Bento ── */
/* ── Funciones apiladas ── */
.tl-stack{position:relative}
.tl-stack-item{position:sticky;top:calc(100px + var(--i) * 14px);padding-bottom:28px}
.tl-stack-item:last-child{padding-bottom:0}
.tl-stack-card{position:relative;overflow:hidden;isolation:isolate;display:grid;grid-template-columns:1fr 1.05fr;gap:48px;align-items:center;min-height:470px;padding:48px 52px;border-radius:36px;
  transform:scale(var(--s,1));transform-origin:50% 0;will-change:transform;
  box-shadow:0 -18px 50px -28px rgba(0,0,0,.35),0 1px 0 rgba(0,0,0,.03)}
.tl-stack-card:after{content:'';position:absolute;inset:0;z-index:5;border-radius:inherit;background:#000;opacity:var(--dim,0);pointer-events:none}
.tl-stack-light{background:var(--card);color:var(--ink)}
.tl-stack-dark{background:#0b0b0b;color:#fff}
.tl-stack-lime{background:radial-gradient(120% 120% at 80% 0%,#e7fbb4 0%,#c6f05a 40%,#a3e31c 80%,#84cc16 100%);color:var(--ink)}
.tl-stack-meta{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.tl-stack-num{font-size:14px;font-weight:700;font-variant-numeric:tabular-nums;opacity:.5}
.tl-stack-kicker{font-size:12.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:6px 12px;border-radius:999px}
.tl-stack-light .tl-stack-kicker{background:#fff;color:var(--lime-d)}
.tl-stack-dark .tl-stack-kicker{background:rgba(163,227,28,.16);color:var(--lime)}
.tl-stack-lime .tl-stack-kicker{background:var(--ink);color:var(--lime)}
.tl-stack-copy h3{font-size:clamp(28px,3.4vw,42px);line-height:1.06;letter-spacing:-.04em;font-weight:700;margin:0 0 16px;max-width:480px}
.tl-stack-copy p{font-size:17px;line-height:1.6;margin:0 0 24px;max-width:460px}
.tl-stack-light .tl-stack-copy p{color:var(--muted)}
.tl-stack-dark .tl-stack-copy p{color:rgba(255,255,255,.7)}
.tl-stack-lime .tl-stack-copy p{color:#27400a}
.tl-stack-copy ul{list-style:none;margin:0;padding:0;display:grid;gap:11px}
.tl-stack-copy li{display:flex;align-items:center;gap:10px;font-size:15px;font-weight:500}
.tl-stack-copy li span{width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex:none}
.tl-stack-light .tl-stack-copy li span{background:var(--lime-t);color:var(--lime-d)}
.tl-stack-dark .tl-stack-copy li span{background:rgba(163,227,28,.18);color:var(--lime)}
.tl-stack-lime .tl-stack-copy li span{background:var(--ink);color:var(--lime)}
.tl-stack-ui .tl-ui{color:var(--ink);transition:transform .7s var(--spring)}
.tl-stack-card:hover .tl-stack-ui .tl-ui{transform:translateY(-6px)}
.tl-stack-dark .tl-stack-ui .tl-ui{box-shadow:0 24px 60px -24px rgba(0,0,0,.7)}
@media (max-height:600px){.tl-stack-item{position:relative;top:auto}}

/* ── Para quién (sectores) ── */
.tl-sector{position:relative;border-radius:30px;padding:30px;display:flex;flex-direction:column;min-height:440px;transition:transform .6s var(--spring),box-shadow .5s}
.tl-sector:hover{transform:translateY(-6px);box-shadow:0 30px 60px -30px rgba(0,0,0,.3)}
.tl-sector-1{background:var(--card);color:var(--ink)}
.tl-sector-2{background:#0b0b0b;color:#fff}
.tl-sector-3{background:radial-gradient(120% 120% at 80% 0%,#e7fbb4 0%,#c6f05a 40%,#a3e31c 80%,#84cc16 100%);color:var(--ink)}
.tl-sector-art{position:relative;width:64px;height:64px;margin-bottom:34px}
.tl-sector-ico{position:relative;z-index:1;width:64px;height:64px;border-radius:20px;display:flex;align-items:center;justify-content:center;background:var(--ink);color:var(--lime);transition:transform .6s var(--spring)}
.tl-sector-2 .tl-sector-ico{background:var(--lime);color:var(--ink)}
.tl-sector:hover .tl-sector-ico{transform:rotate(-8deg) scale(1.08)}
.tl-sector-ring{position:absolute;left:0;top:0;width:64px;height:64px;border-radius:20px;border:1.5px solid var(--lime-d);opacity:0;pointer-events:none}
.tl-sector-2 .tl-sector-ring{border-color:var(--lime)}
.tl-sector-3 .tl-sector-ring{border-color:var(--ink)}
.tl-sector:hover .tl-sector-ring{animation:tl-sector-ripple 1.6s var(--ease) infinite}
.tl-sector:hover .tl-sector-ring-2{animation-delay:.8s}
@keyframes tl-sector-ripple{0%{transform:scale(1);opacity:.55}100%{transform:scale(1.9);opacity:0}}
.tl-sector-kicker{font-size:12.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin-bottom:10px;color:var(--lime-d)}
.tl-sector-2 .tl-sector-kicker{color:var(--lime)}
.tl-sector-3 .tl-sector-kicker{color:#27400a}
.tl-sector h3{font-size:24px;line-height:1.15;letter-spacing:-.03em;font-weight:700;margin:0 0 12px}
.tl-sector p{font-size:15.5px;line-height:1.6;margin:0 0 24px;color:var(--muted)}
.tl-sector-2 p{color:rgba(255,255,255,.7)}
.tl-sector-3 p{color:#27400a}
.tl-sector-tags{display:flex;flex-wrap:wrap;gap:6px;margin-top:auto}
.tl-sector-tags span{font-size:12.5px;font-weight:600;padding:6px 11px;border-radius:999px;background:#fff;color:var(--ink2)}
.tl-sector-2 .tl-sector-tags span{background:rgba(255,255,255,.1);color:#fff}
.tl-sector-3 .tl-sector-tags span{background:rgba(255,255,255,.55);color:var(--ink)}

/* ── Ecosistema (abanico de tarjetas) ── */
.tl-eco-split{grid-template-columns:.9fr 1.1fr}
.tl-eco-pillars{list-style:none;margin:26px 0 0;padding:0;display:grid;gap:18px}
.tl-eco-pillars li{display:flex;gap:14px}
.tl-eco-pillars li>span{width:26px;height:26px;border-radius:50%;background:var(--lime-t);color:var(--lime-d);display:flex;align-items:center;justify-content:center;flex:none;margin-top:1px}
.tl-eco-pillars b{display:block;font-size:17px;letter-spacing:-.01em;margin-bottom:3px}
.tl-eco-pillars p{margin:0;font-size:15px;line-height:1.55;color:var(--muted)}
.tl-eco{position:relative}
.tl-eco:before{content:'';position:absolute;inset:10% 6% 22%;border-radius:40px;background:radial-gradient(circle at 50% 45%,rgba(163,227,28,.4),transparent 70%);filter:blur(34px);pointer-events:none}
.tl-eco-stage{--k:.85;--fan:22px;position:relative;height:calc(392px * var(--k) + var(--fan) * 2 + 6px)}
.tl-eco-card{position:absolute;left:0;bottom:0;width:calc(560px * var(--k));height:calc(392px * var(--k));border-radius:20px;overflow:hidden;cursor:pointer;outline:none;
  background:#F5F5F3;box-shadow:0 30px 70px -32px rgba(0,0,0,.38),0 0 0 1px rgba(0,0,0,.07);
  transform:translate3d(calc(var(--p) * var(--fan)),calc(var(--p) * var(--fan) * -1),0) rotate(calc(var(--p) * 2deg)) scale(calc(1 - var(--p) * .04));
  transform-origin:50% 100%;filter:brightness(calc(1 - var(--p) * .05));
  transition:transform .75s var(--spring),opacity .5s,box-shadow .4s,filter .5s}
.tl-eco-card.tl-front:hover{box-shadow:0 40px 80px -30px rgba(0,0,0,.42),0 0 0 1px rgba(0,0,0,.07)}
.tl-eco-card:focus-visible{box-shadow:0 0 0 3px #fff,0 0 0 5px var(--lime2)}
.tl-eco-card.tl-out{transform:translate3d(-38%,30px,0) rotate(-9deg) scale(.9);opacity:0;transition:transform .42s var(--ease),opacity .42s}
.tl-eco-canvas{width:560px;height:392px;transform:scale(var(--k));transform-origin:0 0;pointer-events:none}
.tl-eco-nav{position:relative;display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-top:26px}
.tl-eco-dot{height:36px;padding:0 16px;border-radius:999px;border:1px solid var(--line);background:#fff;font:inherit;font-size:14px;font-weight:600;color:#3f3f46;cursor:pointer;
  transition:background .3s,color .3s,border-color .3s,transform .45s var(--spring)}
.tl-eco-dot:hover{transform:translateY(-2px);border-color:#d4d4d0}
.tl-eco-dot.tl-sel{background:var(--ink);border-color:var(--ink);color:var(--lime)}
.tl-eco-hint{position:relative;display:flex;align-items:center;justify-content:center;gap:8px;margin:14px 0 0;font-size:13px;color:var(--soft)}

/* Réplica de la plataforma (lienzo 560×392). Valores tomados de Dashboard.js, Conversations.js y Orders.js. */
.ap-screen{width:560px;height:392px;background:#F5F5F3;color:#0F0F10;display:flex;flex-direction:column;text-align:left;
  font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;-webkit-font-smoothing:antialiased}
.ap-cv{background:#f0f0ee}
.ap-top{height:40px;flex:none;display:flex;align-items:center;justify-content:space-between;padding:0 14px}
.ap-brand{display:flex;align-items:center;gap:6px;font-size:12px;letter-spacing:-.2px}
.ap-brand img{width:16px;height:16px;display:block}
.ap-nav{display:flex;gap:2px;background:rgba(255,255,255,.78);border:1px solid rgba(255,255,255,.65);border-radius:999px;padding:3px;box-shadow:0 2px 10px rgba(0,0,0,.06)}
.ap-nav span{font-size:9.5px;font-weight:500;color:#555;padding:4px 11px;border-radius:999px}
.ap-nav span.ap-nav-on{background:linear-gradient(145deg,#1f1f1f,#0a0a0a);color:#fff;font-weight:700;box-shadow:inset 0 1px 0 rgba(255,255,255,.12),0 2px 6px rgba(0,0,0,.22)}
.ap-prof i{display:flex;width:24px;height:24px;border-radius:50%;background:#c4b5fd;color:#fff;font-size:10px;font-weight:700;font-style:normal;align-items:center;justify-content:center}

.ap-db-in{flex:1;padding:4px 16px 14px;display:flex;flex-direction:column;gap:10px;min-height:0}
.ap-db-head{display:flex;justify-content:space-between;align-items:flex-start}
.ap-db-greet{font-size:17px;font-weight:640;letter-spacing:-.3px}
.ap-db-sub{font-size:9px;color:#6B7280;margin-top:3px}
.ap-pills{display:inline-flex;background:#fff;border-radius:9px;padding:3px;box-shadow:0 1px 2px rgba(0,0,0,.04)}
.ap-pills span{font-size:8.5px;font-weight:600;color:#6B7280;padding:4px 8px;border-radius:6px}
.ap-pills span.ap-pill-on{background:#6D5AE0;color:#fff}
.ap-card{background:#fff;border-radius:13px;padding:11px 12px;box-shadow:0 1px 2px rgba(0,0,0,.04)}
.ap-kpis{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
.ap-kpi{position:relative}
.ap-kpi-ic{position:absolute;top:10px;right:10px;width:20px;height:20px;border-radius:7px}
.ap-kpi-ic:after{content:'';position:absolute;inset:6.5px;border-radius:2px;background:currentColor}
.ap-kpi-ic.lav{background:#ECE9FB;color:#6D5AE0}
.ap-kpi-ic.blue{background:#E7EDF8;color:#4F79C7}
.ap-kpi-ic.green{background:#E4F3EA;color:#2FA468}
.ap-kpi-lbl{font-size:7.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#9CA3AF}
.ap-kpi-val{font-size:21px;font-weight:680;letter-spacing:-.4px;margin:6px 0 3px;font-variant-numeric:tabular-nums}
.ap-kpi-tr{font-size:8px;color:#9CA3AF}
.ap-kpi-tr.up{color:#2FA468}
.ap-db-grid{display:grid;grid-template-columns:1.55fr 1fr;gap:10px;flex:1;min-height:0}
.ap-ct{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}
.ap-ct b{font-size:10.5px;font-weight:600}
.ap-ct span{font-size:8px;color:#9CA3AF}
.ap-line-svg{display:block;width:100%;height:92px}
.ap-grid{stroke:#F2F2F0;stroke-width:1;vector-effect:non-scaling-stroke}
.ap-area{fill:#6D5AE0;opacity:.11}
.ap-line{fill:none;stroke-width:2;vector-effect:non-scaling-stroke;stroke-linejoin:round;stroke-linecap:round}
.ap-line-rev{stroke:#6D5AE0}
.ap-line-ord{stroke:#4F79C7}
.ap-x{display:flex;margin-top:5px}
.ap-x span{flex:1;text-align:center;font-size:7.5px;color:#9CA3AF}
.ap-row{display:flex;align-items:center;gap:7px;padding:5.5px 0}
.ap-row+.ap-row{border-top:1px solid #F4F4F2}
.ap-row-n{font-size:8.5px;color:#374151;width:56px;flex:none}
.ap-track{flex:1;height:7px;background:#F1F1EF;border-radius:4px;overflow:hidden}
.ap-fill{display:block;height:100%;width:var(--w);border-radius:4px}
.ap-fill.lav{background:#6D5AE0}
.ap-fill.green{background:#2FA468}
.ap-fill.blue{background:#4F79C7}
.ap-fill.amber{background:#C58A24}
.ap-row-v{font-size:10px;font-weight:660;width:18px;text-align:right;font-variant-numeric:tabular-nums}

.ap-cv-in{flex:1;display:flex;min-height:0;margin:0 10px 10px;border-radius:14px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.05)}
.ap-cv-list{width:196px;flex:none;background:#fff;border-right:1px solid #ebebeb;padding:10px 0}
.ap-cv-h{display:flex;justify-content:space-between;align-items:center;padding:0 11px 8px}
.ap-cv-h b{font-size:13px;font-weight:700}
.ap-cv-new{font-size:8.5px;font-weight:500;background:#f5f5f5;border-radius:999px;padding:3px 8px}
.ap-cv-search{margin:0 11px 8px;height:22px;border-radius:7px;background:#f5f5f5;font-size:8.5px;color:#c0c0c0;display:flex;align-items:center;padding:0 8px}
.ap-cv-tabs{display:flex;gap:3px;padding:0 11px 6px}
.ap-cv-tabs span{font-size:8px;font-weight:500;color:#888;padding:3px 8px;border-radius:999px;border:1px solid transparent}
.ap-cv-tabs span.ap-tab-on{background:#0a0a0a;border-color:#0a0a0a;color:#fff;font-weight:700}
.ap-ci{display:flex;align-items:center;gap:8px;padding:7px 11px}
.ap-ci-on{background:#f0f0f0}
.ap-ci-av{position:relative;width:30px;height:30px;border-radius:50%;flex:none;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#555}
.ap-ci-av i{position:absolute;bottom:0;left:0;width:8px;height:8px;border-radius:50%;background:#22c55e;border:1.5px solid #fff}
.ap-ci-body{flex:1;min-width:0}
.ap-ci-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:1px}
.ap-ci-top b{font-size:10px;font-weight:700}
.ap-ci-top time{font-size:7.5px;color:#b8b8b8}
.ap-ci-bot{display:flex;align-items:center;justify-content:space-between;gap:4px}
.ap-ci-bot span{font-size:8.5px;color:#9a9a9a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ap-ci-bot em{font-style:normal;min-width:13px;height:13px;border-radius:999px;background:#2196F3;color:#fff;font-size:7px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 3px;flex:none}
.ap-cv-chat{flex:1;display:flex;flex-direction:column;min-width:0;background:rgba(255,255,255,.75)}
.ap-ch{display:flex;align-items:center;gap:8px;padding:9px 12px;border-bottom:1px solid rgba(0,0,0,.06);background:#fff}
.ap-ch-av{position:relative;width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#555;flex:none}
.ap-ch-av i{position:absolute;bottom:-1px;right:-1px;width:11px;height:11px;border-radius:50%;background:#25d366;border:1.5px solid #fff}
.ap-ch div>b{display:block;font-size:11px;font-weight:700;color:#111827}
.ap-ch div>span{display:block;font-size:8px;color:#9CA3AF}
.ap-msgs{flex:1;background:#efeae2;padding:9px 11px;display:flex;flex-direction:column;gap:5px;overflow:hidden}
.ap-date{align-self:center;font-size:7.5px;font-weight:600;color:#54656f;background:#fff;padding:2px 8px;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.08);margin-bottom:2px}
.ap-bub{max-width:78%;padding:5px 8px;font-size:9px;line-height:1.45;box-shadow:0 1px 1px rgba(0,0,0,.06);color:#111}
.ap-bub.in{align-self:flex-start;background:#fff;border:1px solid #e8e8e6;border-radius:0 6px 6px 6px;transform-origin:left top}
.ap-bub.out{align-self:flex-end;background:#d9fdd3;border-radius:6px 0 6px 6px;transform-origin:right top}
.ap-input{position:relative;background:#f0f0f0;padding:6px 10px 8px}
.ap-input span{display:block;border:1px solid #E5E7EB;border-radius:16px;background:#fff;font-size:8.5px;color:#9CA3AF;padding:7px 30px 7px 11px}
.ap-input i{position:absolute;right:15px;top:9px;width:20px;height:20px;border-radius:50%;background:#0a0a0a}

.ap-or-in{flex:1;padding:4px 16px 14px;display:flex;flex-direction:column;min-height:0}
.ap-or-title{font-size:20px;font-weight:700;letter-spacing:-.6px;line-height:1.1}
.ap-or-sub{font-size:8.5px;color:#6B7280;margin:3px 0 9px;font-weight:500}
.ap-fbar{display:flex;gap:3px;background:#fff;border:1px solid #E8E8E8;border-radius:12px;padding:5px;margin-bottom:9px}
.ap-otab{display:flex;align-items:center;gap:4px;font-size:8.5px;font-weight:600;color:#6B7280;padding:0 8px;height:22px;border-radius:7px;white-space:nowrap}
.ap-otab em{font-style:normal;font-size:7px;font-weight:700;padding:1px 5px;border-radius:999px;background:#F0F0F0;color:#9CA3AF}
.ap-otab.ap-otab-on{background:#111827;color:#fff}
.ap-otab.ap-otab-on em{background:rgba(255,255,255,.22);color:#fff}
.ap-tw{background:#fff;border:1px solid #E8E8E8;border-radius:12px;overflow:hidden;flex:1}
.ap-tw-h,.ap-tw-r{display:grid;grid-template-columns:52px 76px 1fr 88px 82px;align-items:center;padding:0 11px}
.ap-tw-h{height:24px;border-bottom:1px solid #F0F0F0}
.ap-tw-h span{font-size:6.5px;font-weight:700;color:#9CA3AF;text-transform:uppercase;letter-spacing:.1em}
.ap-tw-r{height:46px;border-bottom:1px solid #F0F0F0}
.ap-tw-r:last-child{border-bottom:0}
.ap-tw-id{display:flex;align-items:center;gap:4px;font-size:9px;font-weight:700}
.ap-tw-id i{width:9px;height:9px;border-radius:50%;background:#25d366}
.ap-tw-c{font-size:9px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:6px}
.ap-tw-p{display:flex;align-items:center;gap:7px;min-width:0;padding-right:6px}
.ap-tw-p>i{width:28px;height:28px;border-radius:8px;flex:none;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;font-style:normal;color:rgba(0,0,0,.45)}
.ap-tw-p>span{min-width:0}
.ap-tw-p b,.ap-tw-v b{display:block;font-size:9px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ap-tw-v b{font-weight:700}
.ap-tw-p small,.ap-tw-v small{display:block;font-size:7.5px;color:#9CA3AF;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ap-badge{display:inline-flex;align-items:center;gap:3px;font-style:normal;font-size:7px;font-weight:700;padding:3px 7px;border-radius:999px;white-space:nowrap}
.ap-badge i{width:4px;height:4px;border-radius:50%}

/* Animaciones cuando la tarjeta pasa al frente */
.tl-front .ap-line-svg{animation:ap-wipe 1.4s var(--ease) both}
.tl-front .ap-fill{animation:ap-grow 1s var(--ease) both;animation-delay:var(--d)}
.tl-front .ap-kpi{animation:ap-rise .6s var(--ease) both}
.tl-front .ap-kpi:nth-child(2){animation-delay:.08s}
.tl-front .ap-kpi:nth-child(3){animation-delay:.16s}
.tl-front .ap-ci{animation:ap-slide .5s var(--ease) both;animation-delay:var(--d)}
.tl-front .ap-bub{animation:ap-pop .55s var(--spring) both;animation-delay:var(--d)}
.tl-front .ap-tw-r{animation:ap-slide .5s var(--ease) both;animation-delay:var(--d)}
.tl-front .ap-badge{animation:ap-pop .5s var(--spring) both;animation-delay:calc(var(--d) + 250ms)}
@keyframes ap-wipe{from{clip-path:inset(0 100% 0 0)}to{clip-path:inset(0 0 0 0)}}
@keyframes ap-grow{from{width:0}}
@keyframes ap-rise{from{opacity:0;transform:translateY(8px)}}
@keyframes ap-slide{from{opacity:0;transform:translateX(-10px)}}
@keyframes ap-pop{from{opacity:0;transform:scale(.75)}}

/* ── Mini UI ── */
.tl-ui{background:#fff;border-radius:22px;padding:20px;box-shadow:0 1px 0 rgba(0,0,0,.02),0 14px 36px rgba(0,0,0,.06)}
.tl-ui-lg{padding:24px;border-radius:26px}
.tl-ui-top{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:14px}
.tl-ui-label{font-size:13px;font-weight:600;color:var(--ink2)}
.tl-ui-muted{font-size:12px;color:var(--soft)}
.tl-ui-big{font-size:32px;font-weight:700;letter-spacing:-.03em;margin-bottom:8px}
.tl-ui-big small{font-size:14px;font-weight:500;color:var(--muted);letter-spacing:0}
.tl-num{font-variant-numeric:tabular-nums}
.tl-live{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:600;color:var(--lime-d);background:var(--lime-t);padding:4px 10px;border-radius:999px}
.tl-live i{width:6px;height:6px;border-radius:50%;background:var(--lime2);animation:tl-blink 1.6s infinite}
@keyframes tl-blink{0%,100%{opacity:1}50%{opacity:.3}}
.tl-chart{display:block;width:100%;height:110px;clip-path:inset(0 0 0 0);transition:clip-path 1.9s var(--ease) .35s}
.tl-js .tl-chart{clip-path:inset(0 100% 0 0)}
.tl-js .tl-in .tl-chart{clip-path:inset(0 0 0 0)}
.tl-chart-dot{fill:#fff;stroke:#65a30d;stroke-width:2.5;animation:tl-blink 1.6s infinite}
.tl-pill-soft{font-size:12px;font-weight:600;background:var(--card);padding:4px 10px;border-radius:999px;color:var(--ink2)}

.tl-inbox{display:grid;gap:4px}
.tl-inbox-row{position:relative;display:flex;align-items:center;gap:12px;padding:10px;border-radius:14px;transition:opacity .7s var(--ease),transform .7s var(--spring),background .3s;transition-delay:var(--d)}
.tl-inbox-row:first-child{background:var(--lime-t)}
.tl-inbox-row:hover{background:var(--card)}
.tl-js .tl-inbox-row{opacity:0;transform:translateX(26px)}
.tl-js .tl-in .tl-inbox-row{opacity:1;transform:none}
.tl-ch{width:34px;height:34px;border-radius:12px;color:#fff;font-size:11px;font-weight:800;display:flex;align-items:center;justify-content:center;flex:none}
.tl-inbox-txt{flex:1;min-width:0}
.tl-inbox-txt b{display:block;font-size:14px}
.tl-inbox-txt span{display:block;font-size:13px;color:var(--muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.tl-who{font-size:11px;font-weight:600;color:var(--ink2);background:#fff;border:1px solid var(--line);padding:3px 8px;border-radius:999px;flex:none}
.tl-unread{position:absolute;top:9px;left:38px;width:10px;height:10px;border-radius:50%;background:var(--lime2);border:2px solid #fff;animation:tl-ping 2s infinite}

.tl-bubbles{display:flex;flex-direction:column;gap:8px;background:#f7f7f5;border-radius:16px;padding:14px}
.tl-bub{max-width:85%;padding:10px 13px;border-radius:15px;font-size:14px;line-height:1.45;transition:opacity .6s var(--ease),transform .7s var(--spring);transition-delay:var(--d)}
.tl-bub-in{background:#fff;align-self:flex-start;border-top-left-radius:4px;transform-origin:left bottom}
.tl-bub-out{background:var(--ink);color:#fff;align-self:flex-end;border-top-right-radius:4px;transform-origin:right bottom}
.tl-js .tl-bub{opacity:0;transform:scale(.7) translateY(10px)}
.tl-js .tl-in .tl-bub{opacity:1;transform:none}

.tl-track{display:grid;gap:4px}
.tl-track-step{display:flex;align-items:center;gap:12px;font-size:14px;padding:8px 0;color:var(--ink);position:relative;transition:color .5s;transition-delay:var(--d)}
.tl-track-step:not(:last-child):after{content:'';position:absolute;left:11px;top:34px;width:2px;height:12px;background:var(--lime);transform-origin:top;transition:transform .5s var(--ease);transition-delay:calc(var(--d) + 250ms)}
.tl-track-dot{width:24px;height:24px;border-radius:50%;border:2px solid var(--lime);background:var(--lime);color:var(--ink);display:flex;align-items:center;justify-content:center;flex:none;
  transition:background .5s,border-color .5s,transform .6s var(--spring);transition-delay:var(--d)}
.tl-track-step.tl-active{font-weight:600}
.tl-track-step.tl-active .tl-track-dot{background:#fff;color:transparent;border-color:var(--lime2);animation:tl-ping 2s infinite}
.tl-js .tl-track-step{color:var(--soft)}
.tl-js .tl-track-step:not(:last-child):after{transform:scaleY(0)}
.tl-js .tl-track-dot{background:#fff;border-color:var(--line);color:transparent;transform:scale(.8)}
.tl-js .tl-in .tl-track-step{color:var(--ink)}
.tl-js .tl-in .tl-track-step:not(:last-child):after{transform:none}
.tl-js .tl-in .tl-track-step.tl-done .tl-track-dot{background:var(--lime);border-color:var(--lime);color:var(--ink);transform:none}
.tl-js .tl-in .tl-track-step.tl-active .tl-track-dot{border-color:var(--lime2);transform:none}

.tl-pay{display:grid;gap:2px}
.tl-pay-row{display:flex;justify-content:space-between;align-items:center;padding:11px 4px;font-size:14px;border-bottom:1px solid #f3f3f1;transition:opacity .6s var(--ease),transform .6s var(--ease);transition-delay:var(--d)}
.tl-pay-row:last-child{border-bottom:0}
.tl-js .tl-pay-row{opacity:0;transform:translateY(12px)}
.tl-js .tl-in .tl-pay-row{opacity:1;transform:none}
.tl-status{font-size:12px;font-weight:600;padding:4px 10px;border-radius:999px}
.tl-status-ok{background:var(--lime-t);color:var(--lime-d)}
.tl-status-wait{background:#fef3c7;color:#92400e;animation:tl-blink 2s infinite}

.tl-bars{display:grid;gap:14px}
.tl-bars-lbl{display:flex;justify-content:space-between;font-size:13px;color:var(--muted);margin-bottom:6px}
.tl-bars-lbl b{color:var(--ink)}
.tl-bars-track{height:10px;border-radius:999px;background:var(--card);overflow:hidden}
.tl-bars-track div{height:100%;width:var(--w);border-radius:999px;background:linear-gradient(90deg,#c6f05a,var(--lime2));transition:width 1.4s var(--ease);transition-delay:var(--d)}
.tl-js .tl-bars-track div{width:0}
.tl-js .tl-in .tl-bars-track div{width:var(--w)}

.tl-asteps{display:grid;gap:10px}
.tl-astep{display:flex;align-items:center;gap:14px;padding:12px;border-radius:18px;border:1px solid var(--line);transition:background .5s,border-color .5s,opacity .5s,transform .5s var(--spring)}
.tl-astep b{display:block;font-size:14px}
.tl-astep div span{display:block;font-size:13px;color:var(--muted)}
.tl-astep-ico{width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex:none;border:2px solid var(--line);transition:background .4s,border-color .4s}
.tl-astep-ico i{width:8px;height:8px;border-radius:50%;background:var(--line)}
.tl-astep.tl-done .tl-astep-ico{background:var(--lime);border-color:var(--lime)}
.tl-astep.tl-active{background:var(--lime-t);border-color:transparent;transform:scale(1.02)}
.tl-astep.tl-active .tl-astep-ico{border-color:var(--lime2)}
.tl-astep.tl-active .tl-astep-ico i{background:var(--lime2);animation:tl-blink 1s infinite}
.tl-astep.tl-todo{opacity:.5}

.tl-states{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-top:16px}
.tl-states div{background:var(--card);border-radius:14px;padding:12px;transition:transform .5s var(--spring)}
.tl-states div:hover{transform:translateY(-3px)}
.tl-states b{display:block;font-size:20px;letter-spacing:-.02em}
.tl-states div>span{font-size:12px;color:var(--muted);line-height:1.3;display:block}

/* ── Split ── */
.tl-split{display:grid;grid-template-columns:1fr 1fr;gap:64px;align-items:center}
.tl-split-media{background:var(--card);border-radius:34px;padding:32px}
.tl-checklist{list-style:none;margin:28px 0 0;padding:0;display:grid;gap:14px}
.tl-checklist li{display:flex;gap:12px;font-size:16px;line-height:1.5;color:var(--ink2)}
.tl-checklist li span{width:24px;height:24px;border-radius:50%;background:var(--lime-t);color:var(--lime-d);display:flex;align-items:center;justify-content:center;flex:none;margin-top:1px}

/* ── Tarjetas pequeñas ── */
.tl-grid4{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}
.tl-grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
.tl-card{background:var(--card);border-radius:26px;padding:26px;transition:transform .6s var(--spring),box-shadow .5s}
.tl-card:hover{transform:translateY(-5px);box-shadow:0 24px 48px -28px rgba(0,0,0,.28)}
.tl-card-ico{width:46px;height:46px;border-radius:15px;background:#fff;color:var(--ink);display:flex;align-items:center;justify-content:center;margin-bottom:18px;
  box-shadow:0 4px 12px rgba(0,0,0,.05);transition:transform .6s var(--spring),background .3s,color .3s}
.tl-card:hover .tl-card-ico{transform:rotate(-8deg) scale(1.1);background:var(--ink);color:var(--lime)}
.tl-card h3{font-size:18px;letter-spacing:-.015em;font-weight:700;margin:0 0 8px}
.tl-card p{font-size:15px;line-height:1.6;color:var(--muted);margin:0}

/* ── Alianza Talku × Nexus ── */
.tl-nx{--nx:#ff0a78;--nx2:#c2185b;position:relative;overflow:hidden;isolation:isolate;border-radius:42px;background:#0b0b0b;color:#fff;padding:68px 56px 44px}
.tl-nx:before{content:'';position:absolute;inset:0;z-index:-1;pointer-events:none;
  background:radial-gradient(rgba(255,255,255,.08) 1px,transparent 1.3px) 0 0/22px 22px;
  -webkit-mask-image:radial-gradient(ellipse at 50% 30%,#000 25%,transparent 75%);mask-image:radial-gradient(ellipse at 50% 30%,#000 25%,transparent 75%)}
.tl-nx-glow{position:absolute;z-index:-1;border-radius:50%;filter:blur(70px);pointer-events:none}
.tl-nx-glow-1{width:560px;height:560px;right:-160px;top:-220px;background:radial-gradient(circle,rgba(255,10,120,.55),transparent 65%);animation:tl-drift 16s ease-in-out infinite alternate}
.tl-nx-glow-2{width:480px;height:480px;left:-180px;bottom:-220px;background:radial-gradient(circle,rgba(163,227,28,.32),transparent 65%);animation:tl-drift 20s ease-in-out -6s infinite alternate-reverse}
.tl-nx-head{text-align:center;max-width:780px;margin:0 auto 46px}
.tl-nx-badge{display:inline-flex;align-items:center;gap:8px;padding:8px 16px;border-radius:999px;font-size:12.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;
  background:linear-gradient(90deg,rgba(255,10,120,.25),rgba(163,227,28,.2));box-shadow:inset 0 0 0 1px rgba(255,255,255,.18);margin-bottom:30px}
.tl-nx-badge svg{color:#fcd34d;fill:#fcd34d}
.tl-nx-lock{display:flex;align-items:center;justify-content:center;margin-bottom:30px}
.tl-nx-tile{display:flex;align-items:center;justify-content:center;gap:10px;height:78px;padding:0 26px;border-radius:24px;transition:transform 1s var(--spring),opacity .8s}
.tl-nx-talku{background:#fff;box-shadow:0 0 44px -8px rgba(163,227,28,.55)}
.tl-nx-talku img{height:28px;display:block}
.tl-nx-nexus{background:#161616;box-shadow:inset 0 0 0 1px rgba(255,10,120,.45),0 0 44px -6px rgba(255,10,120,.65)}
.tl-nx-nexus img{width:42px;height:42px;object-fit:contain;display:block}
.tl-nx-nexus b{font-size:25px;font-weight:800;letter-spacing:-.03em}
.tl-nx-beam{position:relative;width:128px;height:2px;background:rgba(255,255,255,.14);transform-origin:center;transition:transform 1s var(--ease) .3s}
.tl-nx-beam i{position:absolute;inset:-1px 0;border-radius:2px;background:linear-gradient(90deg,transparent,var(--lime),var(--nx),transparent) no-repeat;background-size:50% 100%;animation:tl-beam 1.8s linear infinite}
@keyframes tl-beam{from{background-position:-100% 0}to{background-position:200% 0}}
.tl-nx-beam:after{content:'×';position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:36px;height:36px;border-radius:50%;background:#0b0b0b;
  box-shadow:inset 0 0 0 1px rgba(255,255,255,.28);display:flex;align-items:center;justify-content:center;font-size:19px;font-weight:600}
.tl-js .tl-nx-talku{transform:translateX(56px) scale(.9);opacity:0}
.tl-js .tl-nx-nexus{transform:translateX(-56px) scale(.9);opacity:0}
.tl-js .tl-nx-beam{transform:scaleX(0)}
.tl-js .tl-in .tl-nx-talku,.tl-js .tl-in .tl-nx-nexus{transform:none;opacity:1}
.tl-js .tl-in .tl-nx-beam{transform:none}
.tl-nx-title{font-size:clamp(48px,7.4vw,92px);line-height:.95;letter-spacing:-.055em;font-weight:800;margin:0 0 22px}
.tl-nx-title em{font-style:normal;background:linear-gradient(135deg,var(--lime),var(--nx));-webkit-background-clip:text;background-clip:text;color:transparent;padding:0 .04em}
.tl-nx-lead{font-size:clamp(17px,1.7vw,20px);line-height:1.6;color:rgba(255,255,255,.72);margin:0 auto;max-width:700px}
.tl-nx-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.tl-nx-card{border-radius:30px;padding:30px;background:rgba(255,255,255,.05);box-shadow:inset 0 0 0 1px rgba(255,255,255,.1);
  transition:transform .6s var(--spring),box-shadow .4s}
.tl-nx-card:hover{transform:translateY(-5px)}
.tl-nx-card-n:hover{box-shadow:inset 0 0 0 1px rgba(255,10,120,.55),0 24px 60px -30px rgba(255,10,120,.7)}
.tl-nx-card-t:hover{box-shadow:inset 0 0 0 1px rgba(163,227,28,.55),0 24px 60px -30px rgba(163,227,28,.6)}
.tl-nx-card.tl-spot:before{background:radial-gradient(420px circle at var(--mx,50%) var(--my,50%),rgba(255,255,255,.08),transparent 60%)}
.tl-nx-label{display:inline-block;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:5px 11px;border-radius:999px;margin-bottom:14px}
.tl-nx-card-n .tl-nx-label{background:rgba(255,10,120,.18);color:#ff7ab5}
.tl-nx-card-t .tl-nx-label{background:rgba(163,227,28,.16);color:var(--lime)}
.tl-nx-card h3{font-size:26px;letter-spacing:-.03em;font-weight:700;margin:0 0 20px}
.tl-nx-card ul{list-style:none;margin:0;padding:0;display:grid;gap:13px}
.tl-nx-card li{display:flex;gap:12px;font-size:15.5px;line-height:1.5;color:rgba(255,255,255,.82);transition:opacity .6s var(--ease),transform .6s var(--ease);transition-delay:var(--d)}
.tl-nx-card li span{width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex:none;margin-top:1px}
.tl-nx-card-n li span{background:rgba(255,10,120,.2);color:#ff7ab5}
.tl-nx-card-t li span{background:rgba(163,227,28,.18);color:var(--lime)}
.tl-js .tl-nx-card li{opacity:0;transform:translateX(-12px)}
.tl-js .tl-in .tl-nx-card li{opacity:1;transform:none}
.tl-nx-foot{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:20px;margin-top:28px}
.tl-btn.tl-nx-btn{background:var(--nx);color:#fff;box-shadow:0 14px 34px -10px rgba(255,10,120,.75),inset 0 1px 0 rgba(255,255,255,.3)}
.tl-btn.tl-nx-btn:hover{background:#ff2b8a}
.tl-nx-carriers{display:flex;flex-wrap:wrap;align-items:center;gap:8px}
.tl-nx-carriers>span:first-child{font-size:13px;font-weight:600;color:rgba(255,255,255,.55);margin-right:4px}
.tl-nx-carrier{height:44px;min-width:92px;padding:8px 14px;border-radius:14px;background:#fff;display:flex;align-items:center;justify-content:center;transition:transform .5s var(--spring)}
.tl-nx-carrier:hover{transform:translateY(-3px) scale(1.05)}
.tl-nx-carrier img{max-height:24px;max-width:78px;object-fit:contain;display:block}

/* ── Pasos ── */
.tl-steps{display:grid;grid-template-columns:repeat(3,1fr);gap:20px}
.tl-step{position:relative;padding-top:24px}
.tl-step:before{content:'';position:absolute;left:0;right:0;top:0;height:2px;background:var(--line)}
.tl-step:after{content:'';position:absolute;left:0;right:0;top:0;height:2px;background:var(--ink);transform-origin:left;transition:transform 1.1s var(--ease);transition-delay:calc(var(--d,0ms) + 200ms)}
.tl-js .tl-step:after{transform:scaleX(0)}
.tl-js .tl-step.tl-in:after{transform:scaleX(1)}
.tl-step small{font-size:14px;font-weight:700;color:var(--lime-d)}
.tl-step h3{font-size:22px;letter-spacing:-.02em;margin:10px 0 8px}
.tl-step p{font-size:15px;line-height:1.6;color:var(--muted);margin:0}

/* ── FAQ ── */
.tl-faq{max-width:800px;margin:0 auto;display:grid;gap:10px}
.tl-qa{background:var(--card);border-radius:22px;transition:background .3s,box-shadow .4s}
.tl-qa.tl-open{background:#fff;box-shadow:0 20px 50px -25px rgba(0,0,0,.25),inset 0 0 0 1px var(--line)}
.tl-q{width:100%;display:flex;justify-content:space-between;align-items:center;gap:16px;padding:22px 24px;background:none;border:0;cursor:pointer;
  font:inherit;font-size:17px;font-weight:600;color:var(--ink);text-align:left}
.tl-q i{position:relative;width:32px;height:32px;border-radius:50%;background:#fff;flex:none;transition:transform .5s var(--spring),background .3s}
.tl-q i:before,.tl-q i:after{content:'';position:absolute;left:50%;top:50%;width:12px;height:2px;border-radius:2px;background:var(--ink);transform:translate(-50%,-50%)}
.tl-q i:after{transform:translate(-50%,-50%) rotate(90deg)}
.tl-open .tl-q i{transform:rotate(135deg);background:var(--lime)}
.tl-a{display:grid;grid-template-rows:0fr;transition:grid-template-rows .5s var(--ease)}
.tl-open .tl-a{grid-template-rows:1fr}
.tl-a>div{overflow:hidden}
.tl-a p{margin:0;padding:0 24px 22px;font-size:15px;line-height:1.65;color:var(--muted);opacity:0;transform:translateY(-6px);transition:opacity .4s,transform .5s var(--ease)}
.tl-open .tl-a p{opacity:1;transform:none;transition-delay:.1s}

/* ── Llamado final ── */
.tl-final{position:relative;overflow:hidden;isolation:isolate;border-radius:40px;padding:96px 32px;text-align:center;
  background:radial-gradient(120% 120% at 50% 0%,#e7fbb4 0%,#c6f05a 40%,#a3e31c 75%,#84cc16 100%);background-size:160% 160%;animation:tl-grad 12s ease-in-out infinite alternate}
.tl-final-blob{position:absolute;z-index:-1;border-radius:50%;filter:blur(40px);pointer-events:none}
.tl-final-blob-1{width:380px;height:380px;background:rgba(255,255,255,.55);left:-80px;top:-120px;animation:tl-drift 14s ease-in-out infinite alternate}
.tl-final-blob-2{width:300px;height:300px;background:rgba(63,98,18,.35);right:-60px;bottom:-120px;animation:tl-drift 18s ease-in-out -5s infinite alternate-reverse}
.tl-final .tl-h2{max-width:660px;margin:0 auto 14px}
.tl-final p{font-size:18px;line-height:1.6;color:#27400a;margin:0 auto 34px;max-width:520px}
.tl-final .tl-cta{justify-content:center}

/* ── Footer ── */
.tl-foot{padding:80px 0 0;overflow:hidden}
.tl-foot-grid{display:grid;grid-template-columns:1.6fr 1fr 1fr 1fr;gap:32px}
.tl-foot-brand img{height:26px;margin-bottom:16px;display:block}
.tl-foot-brand p{margin:0;font-size:15px;line-height:1.6;color:var(--muted);max-width:300px}
.tl-foot h4{font-size:15px;font-weight:700;margin:0 0 16px}
.tl-foot ul{list-style:none;margin:0;padding:0;display:grid;gap:11px;font-size:15px;color:var(--muted)}
.tl-foot ul a{position:relative;transition:color .25s}
.tl-foot ul a:after{content:'';position:absolute;left:0;right:0;bottom:-2px;height:1.5px;background:var(--lime2);transform:scaleX(0);transform-origin:left;transition:transform .4s var(--ease)}
.tl-foot ul a:hover{color:var(--ink)}
.tl-foot ul a:hover:after{transform:scaleX(1)}
.tl-foot-bottom{display:flex;flex-wrap:wrap;justify-content:space-between;gap:12px;margin-top:56px;padding-top:24px;border-top:1px solid var(--line);font-size:14px;color:var(--soft)}
.tl-wordmark{display:flex;justify-content:center;font-size:clamp(120px,27vw,360px);font-weight:800;letter-spacing:-.07em;line-height:.8;margin:40px 0 0;user-select:none}
.tl-wordmark span{display:inline-block;background:linear-gradient(180deg,var(--lime) 0%,rgba(163,227,28,.55) 45%,rgba(163,227,28,0) 95%);
  -webkit-background-clip:text;background-clip:text;color:transparent;transition:transform 1.1s var(--spring),opacity .9s;transition-delay:var(--d)}
.tl-js .tl-wordmark span{transform:translateY(55%);opacity:0}
.tl-js .tl-wordmark.tl-in span{transform:none;opacity:1}
.tl-wordmark span:hover{transform:translateY(-6%)!important;transition-delay:0s}

/* ── Responsive ── */
@media (max-width:1060px){
  .tl-links{display:none}
  .tl-burger{display:inline-flex}
  .tl-mobile{display:block}
  .tl-actions .tl-btn-text{display:none}
  .tl-hero-grid,.tl-split{grid-template-columns:1fr}
  .tl-split{gap:40px}
  .tl-split-rev .tl-split-media{order:2}
  .tl-grid4{grid-template-columns:repeat(2,1fr)}
  .tl-foot-grid{grid-template-columns:1fr 1fr}
  .tl-net{height:580px}
  .tl-nx{padding:56px 32px 40px}
  .tl-stack-card{grid-template-columns:1fr 1fr;gap:32px;padding:40px 36px;min-height:440px}
  .tl-sectors{grid-template-columns:1fr}
  .tl-sector{min-height:0}
}
@media (max-width:720px){
  .tl-wrap{padding:0 16px}
  .tl-nav{top:10px;padding:0 12px}
  .tl-bar{height:58px;padding:0 6px 0 18px}
  .tl-nav.tl-solid .tl-bar{height:54px}
  .tl-prog{left:20px;right:20px}
  .tl-actions .tl-btn{height:40px;padding:0 14px;font-size:14px}
  .tl-hero{padding-top:104px}
  .tl-stage{min-height:500px;border-radius:28px}
  .tl-phone{width:254px;height:470px}
  .tl-float-in{min-width:0;padding:10px 12px 10px 10px}
  .tl-f1{top:18px;left:12px}
  .tl-f2{top:auto;bottom:160px;right:10px}
  .tl-f3{bottom:22px;left:12px}
  .tl-grid3,.tl-grid4,.tl-steps{grid-template-columns:1fr}
  .tl-sec{padding:76px 0}
  .tl-split-media{padding:16px;border-radius:26px}
  .tl-states{grid-template-columns:repeat(2,1fr)}
  .tl-cta .tl-btn{flex:1 1 auto}
  .tl-carrier{min-width:0;flex:1 1 40%}
  .tl-final{padding:64px 20px;border-radius:28px}
  .tl-foot-grid{grid-template-columns:1fr}
  .tl-net-sec{padding-top:64px}
  .tl-net-cats{gap:6px;margin:-14px 0 20px}
  .tl-net-cat{height:34px;padding:0 12px;font-size:13px}
  .tl-net{height:580px;border-radius:28px}
  .tl-net-ico{width:48px;height:48px;border-radius:15px}
  .tl-net-ico svg,.tl-net-ico img{width:26px;height:26px}
  .tl-net-name{font-size:11px;margin-top:7px}
  .tl-net-core{width:118px;height:54px;border-radius:18px}
  .tl-net-core img{height:18px}
  .tl-net-ring{width:110px;height:110px;margin:-55px 0 0 -55px}
  .tl-net-tip{width:210px;padding:12px 14px}
  .tl-tip-below{top:calc(100% + 32px)}
  .tl-nx{padding:44px 18px 26px;border-radius:30px}
  .tl-nx-badge{margin-bottom:24px}
  .tl-nx-tile{height:58px;padding:0 16px;border-radius:18px}
  .tl-nx-talku img{height:19px}
  .tl-nx-nexus img{width:30px;height:30px}
  .tl-nx-nexus b{font-size:19px}
  .tl-nx-beam{width:52px}
  .tl-nx-beam:after{width:28px;height:28px;font-size:15px}
  .tl-nx-grid{grid-template-columns:1fr}
  .tl-nx-card{padding:22px;border-radius:24px}
  .tl-nx-card h3{font-size:22px}
  .tl-nx-foot{flex-direction:column;align-items:stretch}
  .tl-nx-carriers{justify-content:center}
  .tl-stack-item{top:calc(78px + var(--i) * 8px);padding-bottom:18px}
  .tl-stack-card{grid-template-columns:1fr;gap:20px;padding:26px 20px 20px;min-height:0;border-radius:28px}
  .tl-stack-meta{margin-bottom:14px}
  .tl-stack-copy h3{font-size:25px;margin-bottom:10px}
  .tl-stack-copy p{font-size:15px;margin:0}
  .tl-stack-copy ul{display:none}
}
@media (prefers-reduced-motion:reduce){
  .tl-root *,.tl-root *:before,.tl-root *:after{animation:none!important;transition:none!important}
  .tl-w-em{background-size:100% 100%}
}
`;

// CTA principal: demo por WhatsApp si hay número configurado; si no, registro.
function primaryCta() {
  const wa = whatsappLink('Hola, quiero conocer Talku');
  if (wa) return { href: wa, label: 'Solicitar demo', external: true };
  if (SITE.openSignup) return { href: '/registro', label: 'Crear cuenta' };
  return { href: '/login', label: 'Acceder' };
}

function Cta({ cta, className, arrow, liquid }) {
  const ext = cta.external ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <a href={cta.href} className={className} data-liquid={liquid} {...ext}>
      <span>{cta.label}</span>{arrow && <Icon name="arrow" size={16} />}
    </a>
  );
}

function Head({ kicker, title, sub, left }) {
  return (
    <div className={`tl-head${left ? ' tl-head-left' : ''}`}>
      <span className="tl-kicker" data-reveal="">{kicker}</span>
      <h2 className="tl-h2" data-reveal="" style={{ '--d': '90ms' }}>{title}</h2>
      {sub && <p className="tl-sub" data-reveal="" style={{ '--d': '180ms' }}>{sub}</p>}
    </div>
  );
}

function Checklist({ items }) {
  return (
    <ul className="tl-checklist">
      {items.map((t, i) => (
        <li key={t} data-reveal="" style={{ '--d': `${200 + i * 80}ms` }}>
          <span><Icon name="check" size={14} /></span>{t}
        </li>
      ))}
    </ul>
  );
}

function Faq({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="tl-faq">
      {items.map((f, i) => (
        <div key={f.q} data-reveal="" style={{ '--d': `${i * 60}ms` }}>
          <div className={`tl-qa${open === i ? ' tl-open' : ''}`}>
            <button type="button" className="tl-q" aria-expanded={open === i} onClick={() => setOpen(open === i ? -1 : i)}>
              <span>{f.q}</span><i aria-hidden="true" />
            </button>
            <div className="tl-a"><div><p>{f.a}</p></div></div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Landing() {
  const rootRef = useRef(null);
  const linksRef = useRef(null);
  const lastHover = useRef(null);
  const [solid, setSolid] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState(null);
  const [hovered, setHovered] = useState(null);

  const nav = NAV.filter(n => !n.pricing || SITE.showPricing);
  const cta = primaryCta();
  const signupSecondary = cta.href !== '/registro' && SITE.openSignup;
  const year = new Date().getFullYear();
  const contactWa = whatsappLink();

  useLiquidGlass(rootRef);

  // Revelado al hacer scroll (se activa antes del primer pintado para evitar parpadeo).
  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    const els = root.querySelectorAll('[data-reveal]');
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('tl-in'));
      return undefined;
    }
    root.classList.add('tl-js');
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('tl-in'); io.unobserve(e.target); }
    }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);

  // Header compacto + barra de progreso de lectura.
  useEffect(() => {
    const root = rootRef.current;
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const doc = document.documentElement;
        const max = doc.scrollHeight - doc.clientHeight;
        if (root) root.style.setProperty('--prog', max > 0 ? (window.scrollY / max).toFixed(4) : '0');
        setSolid(window.scrollY > 12);
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => { window.removeEventListener('scroll', onScroll); cancelAnimationFrame(raf); };
  }, []);

  // Sección activa en el menú.
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;
    const ids = NAV.map(n => n.href.slice(1));
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) setActive(e.target.id); });
    }, { rootMargin: '-45% 0px -50% 0px' });
    ids.forEach(id => { const el = document.getElementById(id); if (el) io.observe(el); });
    const onTop = () => { if (window.scrollY < 300) setActive(null); };
    window.addEventListener('scroll', onTop, { passive: true });
    return () => { io.disconnect(); window.removeEventListener('scroll', onTop); };
  }, []);

  // Indicador líquido que se desliza entre los enlaces del menú.
  useLayoutEffect(() => {
    const box = linksRef.current;
    if (!box) return;
    const key = hovered || (active ? `#${active}` : null);
    const link = key ? box.querySelector(`a[href="${key}"]`) : null;
    const ind = box.querySelector('.tl-ind');
    if (!ind) return;
    if (!link) { ind.classList.remove('tl-ind-on'); return; }
    ind.style.setProperty('--ix', `${link.offsetLeft}px`);
    ind.style.setProperty('--iw', `${link.offsetWidth}px`);
    ind.classList.add('tl-ind-on');
  }, [hovered, active]);

  // Brillo que sigue el cursor y botones "magnéticos".
  const resetPointer = (el) => {
    el.style.setProperty('--tx', '0px');
    el.style.setProperty('--ty', '0px');
  };
  const onPointerMove = (e) => {
    if (e.pointerType !== 'mouse') return;
    const el = e.target.closest ? e.target.closest('.tl-btn, .tl-spot, .tl-glass') : null;
    if (lastHover.current && lastHover.current !== el) resetPointer(lastHover.current);
    lastHover.current = el;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    el.style.setProperty('--mx', `${x}px`);
    el.style.setProperty('--my', `${y}px`);
    if (el.classList.contains('tl-btn')) {
      el.style.setProperty('--tx', `${((x - r.width / 2) * 0.14).toFixed(1)}px`);
      el.style.setProperty('--ty', `${((y - r.height / 2) * 0.22).toFixed(1)}px`);
    }
  };
  const onPointerLeave = () => {
    if (lastHover.current) resetPointer(lastHover.current);
    lastHover.current = null;
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="tl-root" ref={rootRef} onPointerMove={onPointerMove} onPointerLeave={onPointerLeave}>
      <style>{LANDING_CSS}</style>

      {/* ── Header fijo de vidrio líquido ── */}
      <header className={`tl-nav${solid || menuOpen ? ' tl-solid' : ''}`}>
        <div className="tl-bar tl-glass" data-liquid={GLASS_BAR}>
          <a href="#inicio" className="tl-brand" aria-label={SITE.brand} onClick={closeMenu}>
            <img src="/logo-talku.png" alt={SITE.brand} />
          </a>
          <nav className="tl-links" ref={linksRef} onMouseLeave={() => setHovered(null)}>
            <span className="tl-ind" aria-hidden="true" />
            {nav.map(n => (
              <a key={n.href} href={n.href} className={active && n.href === `#${active}` ? 'tl-on' : undefined}
                onMouseEnter={() => setHovered(n.href)}>{n.label}</a>
            ))}
          </nav>
          <div className="tl-actions">
            <a href="/login" className="tl-btn tl-btn-text tl-btn-sm">Acceder</a>
            <Cta cta={cta} className="tl-btn tl-btn-sm tl-glass tl-glass-dark" />
            <button type="button" className={`tl-burger${menuOpen ? ' tl-x' : ''}`} aria-label="Menú" aria-expanded={menuOpen}
              onClick={() => setMenuOpen(o => !o)}>
              <span />
            </button>
          </div>
          <span className="tl-prog" aria-hidden="true" />
        </div>
        {menuOpen && (
          <div className="tl-mobile tl-glass" data-liquid={GLASS_CARD}>
            {nav.map(n => <a key={n.href} href={n.href} className="tl-mlink" onClick={closeMenu}>{n.label}</a>)}
            <div className="tl-mobile-btns">
              <a href="/login" className="tl-btn tl-glass">Acceder</a>
              <Cta cta={cta} className="tl-btn tl-glass tl-glass-dark" />
            </div>
          </div>
        )}
      </header>

      {/* ── Portada ── */}
      <section id="inicio" className="tl-hero">
        <span className="tl-blob tl-blob-1" aria-hidden="true" />
        <span className="tl-blob tl-blob-2" aria-hidden="true" />
        <div className="tl-wrap tl-hero-grid">
          <div>
            <span className="tl-eyebrow-pill tl-glass"><i />CRM con inteligencia artificial</span>
            <h1 className="tl-h1" aria-label="Vende por chat, del mensaje a la entrega">
              {HERO_WORDS.map((w, i) => (
                <span key={i} aria-hidden="true" className={`tl-w${w.em ? ' tl-w-em' : ''}`} style={{ '--d': `${120 + i * 70}ms` }}>{w.t}</span>
              ))}
            </h1>
            <p className="tl-lead">
              WhatsApp, Instagram y Messenger en un solo lugar. Tu equipo y la IA atienden, confirman
              pedidos y pagos, generan guías y siguen cada envío hasta tu cliente.
            </p>
            <div className="tl-cta">
              <Cta cta={cta} className="tl-btn tl-btn-lg tl-glass tl-glass-dark" arrow liquid={GLASS_BTN} />
              <a href="#funciones" className="tl-btn tl-btn-lg tl-glass" data-liquid={GLASS_BTN}>Ver funciones</a>
            </div>
          </div>
          <HeroStage />
        </div>
      </section>

      {/* ── Integraciones (red interactiva) ── */}
      <section id="integraciones" className="tl-sec tl-net-sec">
        <div className="tl-wrap">
          <Head kicker="Integraciones" title="Conectado con las herramientas que ya usas"
            sub="Talku es el centro de tu operación: tus canales, tu tienda, tu logística y tus herramientas en una sola red." />
          <div data-reveal="" style={{ '--d': '120ms' }}><IntegrationNetwork /></div>
        </div>
      </section>

      {/* ── Funciones (tarjetas apiladas al hacer scroll) ── */}
      <section id="funciones" className="tl-sec tl-stack-sec">
        <div className="tl-wrap">
          <Head kicker="Funciones" title="Todo lo que tu operación de ventas necesita"
            sub="Atención, pedidos, pagos y logística trabajando juntos, sin saltar entre herramientas." />
          <StackedFeatures />
        </div>
      </section>

      {/* ── IA ── */}
      <section id="ia" className="tl-sec" style={{ paddingTop: 24 }}>
        <div className="tl-wrap tl-split">
          <div className="tl-split-media" data-reveal=""><MiniAgentSteps /></div>
          <div>
            <Head left kicker="Inteligencia artificial" title="Tu mejor asesor nunca se desconecta"
              sub="La IA de Talku atiende, vende y automatiza mientras tu equipo se enfoca en lo que necesita una persona." />
            <Checklist items={AI_POINTS} />
          </div>
        </div>
      </section>

      {/* ── Dashboard ── */}
      <section id="dashboard" className="tl-sec" style={{ paddingTop: 24 }}>
        <div className="tl-wrap tl-split tl-split-rev">
          <div>
            <Head left kicker="Dashboard" title="Decide con datos, no con intuición"
              sub="Todo lo que necesitas para saber cómo va tu negocio, en una sola pantalla." />
            <Checklist items={DASHBOARD_POINTS} />
          </div>
          <div className="tl-split-media" data-reveal="" style={{ '--d': '120ms' }}><MiniDashboard /></div>
        </div>
      </section>

      {/* ── Equipo ── */}
      <section id="equipo" className="tl-sec">
        <div className="tl-wrap tl-split tl-eco-split">
          <div>
            <Head left kicker="Para tu equipo" title="Un ecosistema comercial integrado"
              sub="Dashboard, conversaciones y pedidos sincronizados al instante con tus canales de venta." />
            <ul className="tl-eco-pillars">
              {TEAM_PILLARS.map((p, i) => (
                <li key={p.title} data-reveal="" style={{ '--d': `${200 + i * 90}ms` }}>
                  <span><Icon name="check" size={14} /></span>
                  <div><b>{p.title}</b><p>{p.text}</p></div>
                </li>
              ))}
            </ul>
            <div className="tl-cta" data-reveal="" style={{ '--d': '560ms', marginTop: 32 }}>
              <Cta cta={cta} className="tl-btn tl-btn-lg tl-glass tl-glass-dark" arrow liquid={GLASS_BTN} />
            </div>
          </div>
          <div data-reveal="" style={{ '--d': '120ms' }}><EcoStack /></div>
        </div>
      </section>

      {/* ── Logística ── */}
      <section id="logistica" className="tl-sec" style={{ paddingTop: 24 }}>
        <div className="tl-wrap">
          {/* Alianza oficial Talku × Nexus */}
          <div data-reveal="">
            <div className="tl-nx">
              <span className="tl-nx-glow tl-nx-glow-1" aria-hidden="true" />
              <span className="tl-nx-glow tl-nx-glow-2" aria-hidden="true" />
              <div className="tl-nx-head">
                <span className="tl-nx-badge"><Icon name="star" size={15} />Logística · Alianza oficial</span>
                <div className="tl-nx-lock" role="img" aria-label="Talku y Nexus">
                  <span className="tl-nx-tile tl-nx-talku"><img src="/logo-talku.png" alt="" /></span>
                  <span className="tl-nx-beam"><i /></span>
                  <span className="tl-nx-tile tl-nx-nexus"><img src="/nexus-logo.png" alt="" /><b>Nexus</b></span>
                </div>
                <h2 className="tl-nx-title">Talku <em>×</em> Nexus</h2>
                <p className="tl-nx-lead">
                  Nexus es la plataforma de dropshipping que pone miles de productos y la logística de todo el país
                  al alcance de tu negocio. Talku es su principal aliado: el CRM con IA que convierte cada conversación
                  en un pedido listo para despachar con Nexus.
                </p>
              </div>
              <div className="tl-nx-grid">
                <div className="tl-nx-card tl-nx-card-n tl-spot">
                  <span className="tl-nx-label">Nexus</span>
                  <h3>La plataforma de dropshipping</h3>
                  <ul>
                    {NEXUS_FACTS.map((f, i) => (
                      <li key={f} style={{ '--d': `${300 + i * 90}ms` }}><span><Icon name="check" size={13} /></span>{f}</li>
                    ))}
                  </ul>
                </div>
                <div className="tl-nx-card tl-nx-card-t tl-spot">
                  <span className="tl-nx-label">Talku</span>
                  <h3>Su principal aliado</h3>
                  <ul>
                    {TALKU_FOR_NEXUS.map((f, i) => (
                      <li key={f} style={{ '--d': `${450 + i * 90}ms` }}><span><Icon name="check" size={13} /></span>{f}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="tl-nx-foot">
                <a href={NEXUS_URL} target="_blank" rel="noopener noreferrer" className="tl-btn tl-btn-lg tl-nx-btn">
                  <span>Conocer Nexus</span><Icon name="external" size={16} />
                </a>
                <div className="tl-nx-carriers">
                  <span>Envíos con</span>
                  {CARRIERS.map(c => (
                    <span className="tl-nx-carrier" key={c.alt}><img src={c.src} alt={c.alt} loading="lazy" /></span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Seguridad ── */}
      <section id="seguridad" className="tl-sec">
        <div className="tl-wrap">
          <Head kicker="Equipo y seguridad" title="Control total, información protegida" />
          <div className="tl-grid4">
            {SECURITY_POINTS.map((p, i) => (
              <div className="tl-card tl-spot" key={p.title} data-reveal="" style={{ '--d': `${i * 80}ms` }}>
                <div className="tl-card-ico"><Icon name={p.icon} /></div>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Cómo funciona ── */}
      <section id="como-funciona" className="tl-sec" style={{ paddingTop: 24 }}>
        <div className="tl-wrap">
          <Head kicker="Cómo funciona" title="Empieza en tres pasos" />
          <div className="tl-steps">
            {STEPS.map((s, i) => (
              <div className="tl-step" key={s.n} data-reveal="" style={{ '--d': `${i * 140}ms` }}>
                <small>{s.n}</small>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Para quién ── */}
      <section id="sectores" className="tl-sec">
        <div className="tl-wrap">
          <Head kicker="Para quién" title="Diseñado para las empresas y tiendas que mueven a Colombia"
            sub="Ya sea que atiendas cientos de pedidos por WhatsApp, coordines un equipo comercial o respondas las consultas de tus clientes, Talku se ajusta a la operación diaria de tu negocio." />
          <div className="tl-grid3 tl-sectors">
            {SECTORS.map((s, i) => (
              <div className={`tl-sector tl-sector-${i + 1} tl-spot`} key={s.title} data-reveal="" style={{ '--d': `${i * 110}ms` }}>
                <div className="tl-sector-art" aria-hidden="true">
                  <span className="tl-sector-ico"><Icon name={s.icon} size={26} /></span>
                  <span className="tl-sector-ring" />
                  <span className="tl-sector-ring tl-sector-ring-2" />
                </div>
                <span className="tl-sector-kicker">{s.kicker}</span>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
                <div className="tl-sector-tags">{s.tags.map(t => <span key={t}>{t}</span>)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Precios (oculto hasta definir planes: SITE.showPricing) ── */}
      {SITE.showPricing && (
        <section id="precios" className="tl-sec">
          <div className="tl-wrap">
            <Head kicker="Precios" title="Planes" sub="Pendiente de definir." />
          </div>
        </section>
      )}

      {/* ── FAQ ── */}
      <section id="faq" className="tl-sec" style={{ paddingTop: 24 }}>
        <div className="tl-wrap">
          <Head kicker="Preguntas frecuentes" title="Resolvemos tus dudas" />
          <Faq items={FAQS} />
        </div>
      </section>

      {/* ── Llamado final ── */}
      <section id="contacto" className="tl-sec" style={{ paddingTop: 24 }}>
        <div className="tl-wrap">
          <div data-reveal="">
          <div className="tl-final">
            <span className="tl-final-blob tl-final-blob-1" aria-hidden="true" />
            <span className="tl-final-blob tl-final-blob-2" aria-hidden="true" />
            <h2 className="tl-h2">¿Listo para vender más por chat?</h2>
            <p>Conecta tus canales y empieza a atender, confirmar y despachar desde un solo lugar.</p>
            <div className="tl-cta">
              <Cta cta={cta} className="tl-btn tl-btn-lg tl-glass tl-glass-dark" arrow liquid={GLASS_BTN} />
              {signupSecondary
                ? <a href="/registro" className="tl-btn tl-btn-lg tl-glass" data-liquid={GLASS_BTN}>Crear cuenta</a>
                : <a href="/login" className="tl-btn tl-btn-lg tl-glass" data-liquid={GLASS_BTN}>Acceder</a>}
            </div>
          </div>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="tl-foot">
        <div className="tl-wrap">
          <div className="tl-foot-grid">
            <div className="tl-foot-brand" data-reveal="">
              <img src="/logo-talku.png" alt={SITE.brand} />
              <p>CRM con inteligencia artificial para vender por chat: atención, pedidos, pagos y logística en un solo lugar.</p>
            </div>
            <div data-reveal="" style={{ '--d': '80ms' }}>
              <h4>Plataforma</h4>
              <ul>
                <li><a href="#funciones">Funciones</a></li>
                <li><a href="#integraciones">Integraciones</a></li>
                <li><a href="#ia">Inteligencia artificial</a></li>
                <li><a href="#dashboard">Dashboard</a></li>
                <li><a href="#logistica">Logística</a></li>
                {SITE.showPricing && <li><a href="#precios">Precios</a></li>}
                <li><a href="#faq">Preguntas frecuentes</a></li>
              </ul>
            </div>
            <div data-reveal="" style={{ '--d': '160ms' }}>
              <h4>Legal</h4>
              <ul>
                {LEGAL_LINKS.map(l => <li key={l.href}><a href={l.href}>{l.label}</a></li>)}
              </ul>
            </div>
            <div data-reveal="" style={{ '--d': '240ms' }}>
              <h4>Contacto</h4>
              <ul>
                {contactWa && <li><a href={contactWa} target="_blank" rel="noopener noreferrer">WhatsApp</a></li>}
                {SITE.email && <li><a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>}
                {SITE.city && <li>{SITE.city}</li>}
                <li><a href="/login">Acceder</a></li>
                {SITE.openSignup && <li><a href="/registro">Crear cuenta</a></li>}
              </ul>
            </div>
          </div>
          <div className="tl-foot-bottom">
            <span>© {year} {SITE.brand}. Todos los derechos reservados.</span>
            <span>{SITE.domain}</span>
          </div>
        </div>
        <div className="tl-wordmark" data-reveal="custom" aria-hidden="true">
          {'Talku'.split('').map((c, i) => <span key={i} style={{ '--d': `${i * 90}ms` }}>{c}</span>)}
        </div>
      </footer>
    </div>
  );
}
